import React from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import useStyles from "@hooks/useStyles";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Header from "@components/Main/Shared/Header";
import Footer from "@components/Main/Shared/Footer";

const { LINK_HELP, LINK_HELP_CONTACT, BRAND_NAME, SITE_NAME } = process.env;
const { CORP_NAME } = "Liaison, Inc.";

const Terms = () => {
	const classes = useStyles("Terms");

	return (
		<React.Fragment>
			<Header />
			{/* CRM NOTES
			
			Tos CC rates subject to change at any time for any reason without warning
			https://www.marketing360.com/payment-terms & Liaison  & Liaison....
			 */}

			<Box p={"16px 0px"} bgcolor={"#f8f9fa"}>
				<Container maxWidth={"lg"}>
					<Box
						p={{ xs: "24px", sm: "40px 80px 60px" }}
						style={{ boxShadow: "rgba(60, 64, 67, 0.15) 0px 1px 3px 1px" }}
						bgcolor={"#FFF"}
						borderRadius={10}
					>
						<Box lineHeight={1.6} className={classes.body}>
							<h1>
								<strong>Terms of Use</strong>
							</h1>
							<p>
								<strong>
									IMPORTANT NOTICE: THIS AGREEMENT CONTAINS A BINDING
									ARBITRATION PROVISION AND CLASS ACTION WAIVER. IT AFFECTS YOUR
									LEGAL RIGHTS AS DETAILED IN THE ARBITRATION AND CLASS ACTION
									WAIVER SECTION BELOW. PLEASE READ CAREFULLY.
								</strong>
							</p>
							<p>
								<span>
									Liaison, Inc and its affiliates (collectively, "Liaison,"
									"our," "us," or "we") operate websites, provide products and
									services through mobile and other applications, and develop
									software. We refer to these as &ldquo;platform,&rdquo;
									"sites," "services," or "our sites and services."
								</span>
							</p>
							<p>
								<span>
									As used in these TOU, references to our "Affiliates" include
									our owners, subsidiaries, affiliated companies, officers,
									directors, suppliers, partners, sponsors, and advertisers, and
									includes (without limitation) all parties involved in
									creating, producing, and/or delivering this site and/or its
									contents.
								</span>
							</p>
							<p>
								<span>
									PLEASE READ THE TERMS THOROUGHLY AND CAREFULLY. BY USING THE
									PLATFORM, YOU AGREE TO BE BOUND BY THESE TERMS. IF YOU DO NOT
									AGREE TO THESE TERMS, THEN YOU MAY NOT ACCESS OR USE THE
									PLATFORM.
								</span>
							</p>
							<p>
								<span>
									These terms, including any schedules and supplemental terms
									(collectively, these "Terms of Use" or this "TOU") applies to
									our sites and services on which we display or post a direct
									link to this TOU. If there is any conflict between this TOU
									and any supplemental terms to a site or service, the
									supplemental terms will control. This TOU does not apply to
									those sites and services that do not display or link to this
									TOU, or that have their own terms of use.
								</span>
							</p>
							<p>
								<span>
									By using our sites and services, you are a "user" and you
									accept and agree to this TOU as a legal contract between you
									and us. We reserve the right to change these TOU from time to
									time without notice to you. You acknowledge and agree that it
									is your responsibility to review this site and these TOU
									periodically and to be aware of any modifications. Your
									continued use of this site after such modifications will
									constitute your acknowledgment of the modified TOU and
									agreement to abide and be bound by the modified Terms of Use.
									If you do not accept and agree to all provisions of these TOU,
									now or in the future, you may reject these TOU by immediately
									terminating all access and use of our sites and services, in
									which case any continuing access or use of our sites and
									service is unauthorized.
								</span>
							</p>
							<p>
								<span>
									This TOU governs your access to, use of, and participation in
									the sites and services made available by Liaison or provider
									services obtained from or provided to other users. All
									references to "you" or "your," as applicable, mean the person
									who accesses, uses, and/or participates in the Platform in any
									manner, and each of your heirs, assigns, and successors. If
									you use the Platform on behalf of an entity, you represent and
									warrant that you have the authority to bind that entity, your
									acceptance of the TOU will be deemed an acceptance by that
									entity, and "you" and "your" herein shall refer to that
									entity, its members, owners, directors, employees, and any
									other agent of that entity. As used in these TOU, references
									to our "Affiliates" include our owners, subsidiaries,
									affiliated companies, officers, directors, suppliers,
									partners, sponsors, and advertisers, and includes (without
									limitation) all parties involved in creating, producing,
									and/or delivering this site and/or its contents.
								</span>
							</p>
							<p>
								<span>
									You are also required to comply with, and to ensure compliance
									with, all laws, ordinances and regulations applicable to your
									activities on our sites and services.
								</span>
							</p>
							<p>
								<span>
									Unless expressly permitted by supplemental terms, our sites
									and services are intended for general audiences 18 years of
									age and older, and access or use by anyone younger is not
									authorized.
								</span>
							</p>
							<p>
								<span>
									These TOU grant you a limited, revocable, nonexclusive license
									to access our sites and services and use our sites and
									services, in whole or in part, including but not limited to
									our intellectual property therein, solely in compliance with
									these TOU. You are prohibited from utilizing, copying,
									adapting, modifying, creating derivative works from,
									distributing, licensing, selling, transferring, publicly
									displaying, publicly performing, transmitting, streaming,
									broadcasting, or otherwise exploiting the Platform or
									Collective Content, other than what is explicitly allowed in
									these Terms. Liaison or our licensors do not grant you any
									implied licenses or rights concerning any intellectual
									property that they own or control. The only licenses and
									rights you obtain are those expressly outlined in these Terms.
								</span>
							</p>
							<p>
								<span>
									YOUR REMEDY FOR DISSATISFACTION WITH OUR SITES AND SERVICES,
									CONTENT, OR OTHER INFORMATION AVAILABLE ON OR THROUGH OUR
									SITES, IS TO STOP USING THESE SITES AND SERVICES. YOUR
									AGREEMENT WITH US REGARDING COMPLIANCE WITH THESE TERMS OF USE
									BECOMES EFFECTIVE IMMEDIATELY UPON COMMENCEMENT OF YOUR USE OF
									OUR SITES AND SERVICES.
								</span>
							</p>
							<h2>
								<strong>Additional Terms and Policies</strong>
							</h2>
							<p>
								<span>Please review our </span>
								<a href="/privacy-policy">
									<span>Privacy Policy</span>
								</a>
								<span>
									{" "}
									for information and notices concerning Liaison&rsquo;s
									collection and use of your information. The provision and
									delivery of text messages by Liaison or our text message
									service providers is governed by our SMS Terms and Conditions,
									which are expressly incorporated herein. Certain areas of
									and/or products on the Platform may have different terms and
									conditions posted or may require you to agree with and accept
									additional terms and conditions or policies. If there is a
									conflict between these Terms and terms and conditions or
									policies posted for a specific area or product, the latter
									take precedence with respect to your use of that area or
									product.
								</span>
							</p>

							<h3>
								<strong>
									Certain Brand-Specific and Business-Model Specific Disclaimers
								</strong>
							</h3>
							<p>
								<span>
									As noted above, the use of certain of our sites and services
									also have supplemental terms based on the subject matter and
									content of the specific site or services, including our sites
									and services set forth below. You can find the supplemental
									terms governing those specific sites and services below:
								</span>
							</p>
							<p>
								<a href="/terms-of-service/terms-payments">
									<span>Payments, ACH, Financial Services Terms</span>
								</a>
							</p>
							<p>
								<a href="/terms-of-service/terms-pos">
									<span>
										{" "}
										Point of Sale, Bookings, Customer Management Terms of
										Service
									</span>
								</a>
							</p>
							<p>
								<a href="/terms-of-service/terms-health">
									<span>Health Sites and Services Terms</span>
								</a>
							</p>
							<p>
								<a href="/terms-of-service/terms-legal">
									<span>Legal Sites and Services Terms</span>
								</a>
							</p>

							<h2>
								<strong>Key Terms</strong>
							</h2>
							<p>
								<span>
									"Platform" encompasses all websites, mobile or other
									applications, software, processes, video consultations,
									subscription services, and other services offered by or
									through Liaison.
								</span>
							</p>
							<p>
								<span>
									"Service Professional" or "Professional" or "Subscriber"
									denotes a User who is registered to utilize the Platform to
									propose, deliver, get paid for, or facilitate the delivery of
									Pro Services. Within the Platform, Service Professionals are
									often referred to as &ldquo;pros.&rdquo;
								</span>
							</p>
							<p>
								<span>
									"Consumer" is a term for a User registered on the Platform to
									find Service Professionals, request Pro Services, book Pro
									Services or obtain quotes, engage in consultations or similar
									services, or otherwise utilize the Platform to receive, pay
									for, review, or facilitate the acquisition of Pro Services. As
									Consumers might be or become clients of Service Professionals,
									they may also be referred to as "customers" within the
									Platform and related marketing materials.
								</span>
							</p>
							<p>
								<span>
									"User" identifies an individual or entity that either finishes
									the account registration process with Liaison, adheres to its
									Terms, takes advantage of the services on the Platform, or
									submits or obtains a request via our sites. This includes, but
									isn&rsquo;t limited to, Service Professionals and Consumers.
								</span>
							</p>
							<p>
								<span>
									"Content" encompasses a variety of materials like text,
									images, graphics, audio, software, video, information, and
									more. This includes everything from profile information and
									service requests to quotes, message threads, reviews,
									scheduling details, calendar information, and any other data
									accessible on or through the Platform.
								</span>
							</p>
							<p>
								<span>
									"User Content" constitutes all Content that is submitted,
									posted, uploaded, published, or transmitted by any User or
									other user of the Platform, such as photos, profile details,
									descriptions, postings, reviews, requests, messages, and
									payments, excluding Liaison Content and Feedback.
								</span>
							</p>
							<p>
								<span>
									"Liaison Content" is the Content made available by Liaison on
									or through the Platform, which includes Content licensed from
									third parties but excludes User Content.
								</span>
							</p>
							<p>
								<span>
									"Collective Content" is defined as the combination of User
									Content and Liaison Content.
								</span>
							</p>
							<p>
								<span>
									"Fee" signifies an amount that Liaison charges a User in
									relation to the Platform.
								</span>
							</p>
							<p>
								<span>
									"Pro Services" describes the services that are listed, quoted,
									scheduled, offered, executed, or provided by Service
									Professionals, or sought, scheduled, purchased, or received by
									Consumers, via the Platform.
								</span>
							</p>
							<h2>
								<strong>Moderation</strong>
							</h2>
							<p>
								<span>
									We have the right, but not the obligation, to regulate content
									(which includes but is not limited to postings, text, code,
									images, video, binary files, ads, accounts, account
									information, flags, emails, messages and any other user
									communications ("content")) posted to, stored on or
									transmitted via our sites and services by any user (or any
									other third party in any manner); to regulate conduct
									(including but not limited to any authorized or unauthorized
									access to or use of our sites and services) by any user (or
									any other third party in any manner); and to enforce these
									TOU, for any reason and in any manner or by any means that we,
									in our sole discretion, deem necessary or appropriate
									(including but not limited to automated and manual screening,
									blocking, filtering, exclusion from index pages, exclusion
									from search results, requiring the use of an application
									programming interface (API), requiring the use of a bulk
									posting interface, authorization, verification, and the
									deletion and/or termination of content, accounts and/or all or
									any use or access). We may, in our sole discretion and without
									notice, start, stop or modify any regulation or enforcement
									measures at any time. Our action or inaction to regulate
									content or conduct or to enforce against any potential
									violation of these TOU by any user (or any other third party)
									does not waive our right to implement or not implement
									regulation or enforcement measures with respect to any
									subsequent or similar content, conduct or potential TOU
									violation.
								</span>
							</p>
							<p>
								<span>
									You also understand and agree that any action or inaction by
									us or any of our directors, officers, stockholders, employees,
									consultants, agents or representatives (collectively, "our
									representatives" and individually "our representative") to
									prevent, restrict, redress or regulate content, or to
									implement other enforcement measures against any content,
									conduct or potential TOU violation is undertaken voluntarily
									and in good faith, and you expressly agree that neither we nor
									any of our representatives will be liable to you or anyone
									else for any action or inaction to prevent, restrict, redress,
									or regulate content, or to implement other enforcement
									measures against any content, conduct or potential violation
									of these TOU.
								</span>
							</p>
							<p>
								<span>
									Although our representatives may moderate content on our sites
									and services at our discretion, our representatives have no
									authority to make binding commitments, promises or
									representations to anyone that they or anyone else on behalf
									of us will "take care" of any alleged problem or complaint, or
									that they or anyone else on behalf of us will otherwise stop,
									cure or prevent any problem, content, conduct or purported TOU
									violation from occurring or recurring. Accordingly, you
									further agree that any representation (written or verbal) by
									our representative (or by anyone else acting on behalf of us
									or by anyone purportedly acting on behalf of us) that we
									(including but not limited to our representative, anyone else
									acting on behalf of us, or anyone purportedly acting on behalf
									of us) would or would not prevent, restrict, redress or
									regulate content (including, without limitation, screen,
									block, moderate, review, remove, terminate, delete, edit or
									otherwise stop, cure or exclude any content), or to implement
									other enforcement measures against any content, conduct or
									potential or purported TOU violation is superseded by this
									provision and is nonbinding and unenforceable. Specifically,
									you agree that we, our representatives and anyone else
									authorized to act on behalf of us will in no circumstance be
									liable as a result of any representation that we, our
									representatives or anyone else on behalf of us would or would
									not restrict or redress any content, conduct or potential or
									purported TOU violation. For the purpose of clarity, the
									opinions, statements, comments, posts and other communications
									expressed on our sites and services are solely those of the
									poster and not ours, or our employees, officers, directors,
									shareholders, subsidiaries, parent companies, attorneys or
									other agents. We do not guarantee the accuracy or reliability
									or the information provided by any poster, administrator, or
									moderator. Administrators and moderators are not our agents
									and their opinions, comments and posts are their own. This
									paragraph may not be modified, waived or released except by a
									written agreement, dated and signed by our Chief Executive
									Officer and dated and signed by the individual or entity to
									whom the modification, waiver or release is granted.
								</span>
							</p>
							<p>
								<span>
									We also have the right in our sole discretion to limit,
									modify, interrupt, suspend or discontinue all or any portions
									of our sites and services at any time without notice. We and
									our representatives will not be liable for any such
									limitations, modifications, interruptions, suspensions or
									discontinuance, or any purported losses, harm or damages
									arising from or related thereto.
								</span>
							</p>
							<h2>
								<strong>Content and Conduct</strong>
							</h2>
							<h3>
								<strong>Content</strong>
							</h3>
							<p>
								<span>
									We do not control, are not responsible for and make no
									representations or warranties with respect to any user
									content. You are solely responsible for your access to, use of
									and/or reliance on any user content. You must conduct any
									necessary, appropriate, prudent or judicious investigation,
									inquiry, research and due diligence with respect to any user
									content.
								</span>
							</p>
							<p>
								<span>
									You are also responsible for any content that you post or
									transmit and, if you create an account, you are responsible
									for all content posted or transmitted through or by use of
									your account. You accept full responsibility for avoiding
									infringement of the intellectual property or personal rights
									of others in connection with your Content.
								</span>
							</p>
							<p></p>
							<p>
								<span>
									Content prohibited from our sites and services includes but is
									not limited to: (1) illegal content; (2) content in
									facilitation of the creation, advertising, distribution,
									provision or receipt of illegal goods or services; (3)
									offensive content (including, without limitation, court
									ordered defamatory statements, threatening, hateful or
									pornographic content); (4) content that discloses another's
									personal, confidential or proprietary information; (5) false
									or fraudulent content (including but not limited to false,
									fraudulent or misleading responses to user ads transmitted via
									our sites and services); (6) malicious content (including,
									without limitation, malware or spyware); (7) content that
									offers, promotes, advertises, or provides links to posting or
									auto-posting products or services, account creation or
									auto-creation products or services, flagging or auto-flagging
									products or services, bulk telephone numbers, or any other
									product or service that if utilized with respect to our sites
									and services would violate these TOU or our other legal
									rights; and (8) content that offers, promotes, advertises or
									provides links to unsolicited products or services. Other
									content prohibitions are set forth in supplemental terms for
									particular categories or services on our sites and services
									and all such prohibitions are expressly incorporated into
									these TOU as stated in the introductory paragraphs above.
								</span>
							</p>
							<p>
								<span>
									You automatically grant and assign to us, and you represent
									and warrant that you have the right to grant and assign to us,
									a perpetual, irrevocable, unlimited, fully paid, fully
									sub-licensable (through multiple tiers), worldwide license to
									copy, perform, display, sell, transfer, distribute, prepare
									derivative works from (including, without limitation,
									incorporating into other works) and otherwise use any content
									that you post. You also expressly grant and assign to us all
									rights and causes of action to prohibit and enforce against
									any unauthorized copying, performance, display, distribution,
									use or exploitation of, or creation of derivative works from,
									any content that you post (including but not limited to any
									unauthorized downloading, extraction, harvesting, collection
									or aggregation of content that you post). The contents of
									private messaging through the Platform will not be used by
									Liaison in public advertising. For clear understanding, it's
									important to note that the license granted to Liaison will
									continue to be in effect even after the termination of the
									Platform or your Account. Liaison does not assert any
									ownership rights over your User Content, and nothing in these
									Terms should be interpreted as limiting the rights that you
									may possess to use, manage, or exploit any User Content that
									you have submitted, posted, uploaded, published, or
									transmitted on or through the Platform.
								</span>
							</p>
							<h3>
								<strong>Public User Content</strong>
							</h3>
							<p>
								In an effort to enhance user experience and create a
								comprehensive profile, we may, from time to time, gather
								publicly accessible content ("Public Content") that you own or
								control from platforms or profiles outside of Liaison. This may
								include, but is not limited to, pictures, videos, and other
								media or information. Any Public Content we collect might be
								added to your profile on our platform. However, such content
								will remain private and will not be displayed publicly on your
								profile until you have expressly agreed to our terms of use and
								our privacy policy. You retain the right to remove or request
								the removal of any Public Content from your profile at any time,
								irrespective of your agreement to our terms and policies. Once
								you accept our terms and complete your account setup, the Public
								Content on your profile, like any other content you provide or
								that is associated with your profile, will be governed by and
								subject to all applicable terms, policies, and conditions
								stipulated in this agreement and any other relevant documents
								referenced herein. After your acceptance of our terms and
								policies and your subsequent review and approval of the
								collected Public Content, now known as your Content, you assume
								full responsibility for ensuring that your Content does not
								infringe upon the intellectual property or rights of third
								parties. You are solely responsible for any legal implications
								or liabilities arising from potential infringements or
								violations related to your Content.
							</p>

							<h3>
								<strong>Conduct</strong>
							</h3>
							<p>
								<span>
									We do not control, are not responsible for and make no
									representations or warranties with respect to any user or user
									conduct. You are solely responsible for your interaction with
									or reliance on any user or user conduct. You must perform any
									necessary, appropriate, prudent or judicious investigation,
									inquiry, research and due diligence with respect to any user
									or user conduct.
								</span>
							</p>
							<p>
								<span>
									You are also responsible for your own conduct and activities
									on, through or related to our sites and services, and, if you
									create an account on our sites and services, you are
									responsible for all conduct or activities on, through or by
									use of your account.
								</span>
							</p>
							<h2>
								<strong>Postings and Accounts</strong>
							</h2>
							<p>
								<span>
									This section applies to all uses and users of our sites and
									services, unless we have specifically authorized an exception
									to a particular term for a particular user in a written
									agreement. We have sole and absolute discretion to authorize
									or deny any exception or exceptions to the terms in this
									section.
								</span>
							</p>
							<p>
								<strong>Postings</strong>
							</p>
							<p>
								<span>
									Users may not circumvent any technological measure implemented
									by us to restrict the manner in which content may be posted on
									our sites and services or to regulate the manner in which
									content (including but not limited to email) may be
									transmitted to other users. This prohibition includes, without
									limitation, a ban on the use of multiple email addresses
									(created via an email address generator or otherwise); the use
									of multiple IP addresses (via proxy servers, modem toggling,
									or otherwise); CAPTCHA circumvention, automation or
									outsourcing; multiple and/or fraudulent service accounts,
									including phone-verified accounts; URL shortening, obfuscation
									or redirection; use of multiple phone lines or phone
									forwarding for verification; and content obfuscation via HTML
									techniques, printing text on images, inserting random text or
									content "spinning."
								</span>
							</p>
							<p>
								<span>
									It is expressly prohibited for any third party to post content
									to our sites and services on behalf of another. Users must
									post content only on their own behalf, and may not permit,
									enable, induce or encourage any third party to post content
									for them.
								</span>
							</p>
							<p>
								<span>
									It is expressly prohibited to post content to our sites and
									services using any automated means. Users must post all
									content personally and manually through all steps of the
									posting process. It is also expressly prohibited for any user
									to develop, offer, market, sell, distribute or provide an
									automated means to perform any step of the posting process (in
									whole or in part). Any user who develops, offers, markets,
									sells, distributes or provides an automated means to perform
									any step of the posting process (in whole or in part) will be
									responsible and liable to us for each instance of access to
									our sites and services (by any user or other third party)
									using that automated means.
								</span>
							</p>
							<p>
								<span>
									Affiliate marketing by users is expressly prohibited on our
									sites and services. Users may not post content or communicate
									with any user for purposes of affiliate marketing or in
									connection with any affiliate marketing system, scheme or
									program in any manner or under any circumstance.
								</span>
							</p>
							<h3>
								<strong>Accounts</strong>
							</h3>
							<p>
								<span>
									Users may access the Platform without registering for an
									account. For each site, a user may create, maintain and use no
									more than one account to post content only on his/her or its
									own behalf. A user must create his/her or its account
									personally and manually and may not create accounts by any
									automated means. Without limitation, this includes the
									obligation that the user personally and manually solves any
									CAPTCHA challenge in the account creation process. A user may
									not create or use additional accounts or any account of
									another and must not permit, enable, induce or encourage
									others to create accounts for him/her or it.
								</span>
							</p>
							<p>
								<span>
									The purchase and sale of accounts and the creation of accounts
									for others is expressly prohibited. The circumvention of any
									technological restriction or security measure in the account
									creation process, posting process or otherwise for posting
									content in violation of these TOU also is expressly
									prohibited.
								</span>
							</p>
							<p>
								<span>
									You can create an Account using specific third-party
									credentials like your Facebook or Google details (referred to
									as your "Third-Party Site Password"). During the registration
									or request submission process and at any time you use the
									Platform, you commit to supplying information that is current,
									accurate, and complete, as well as to update this information
									to maintain its accuracy and completeness.
								</span>
							</p>
							<p>
								<span>
									The responsibility for safeguarding both your Liaison password
									and, if relevant, your Third-Party Site Password, rests solely
									with you. You are the only one accountable for all activities
									that transpire on your Account. If you become aware of any
									unauthorized use, you must inform Liaison without delay.
									Liaison holds no liability for losses incurred by any party
									due to unauthorized access to your Account.
								</span>
							</p>
							<p>
								<span>
									Should unauthorized use of your account occur as a result of
									your failure to adhere to these Terms, you will be held
									responsible for any subsequent losses incurred by Liaison or
									others. Your account cannot be transferred to another party
									without obtaining written consent from Liaison and in strict
									compliance with the policies and procedures of Liaison.
								</span>
							</p>
							<h2>
								<strong>
									Eligibility, Service Professional Representations, and
									Warranties
								</strong>
							</h2>
							<p>
								<span>
									Only individuals who are at least 18 years old and capable of
									forming legally binding agreements under relevant law are
									allowed to access and use the Platform. When you access or
									utilize the Platform, you are affirming and guaranteeing that
									you fulfill these criteria.
								</span>
							</p>
							<p>
								<span>
									Service Professionals, by using or registering on the Platform
									to propose, post, or provide Pro Services, assure and assert
									that they and their associates, such as employees, agents,
									suppliers, contractors, and subcontractors, possess the
									necessary qualifications, experience, and required licensure,
									certification, bonding, and insurance. These must comply with
									all laws or regulations in the jurisdictions where the Pro
									Services are offered and specific to the work being
									undertaken. Furthermore, Service Professionals agree to adhere
									to all relevant laws, like the California Consumer Privacy
									Act, any other pertinent privacy laws, and the Telephone
									Consumer Protection Act, in their usage of the Platform and
									any personal data obtained from it.
								</span>
							</p>
							<p>
								<span>
									Liaison's role is not as a seller or provider of Pro Services.
									It might offer home project consultations and associated
									on-Platform services to Consumers, but independent Service
									Professionals provide any Pro Services that may be requested
									as a result. Liaison makes no representation or warranty about
									these services, except as explicitly stated. Liaison&rsquo;s
									facilitation of Pro Service transactions may include actions
									such as listing Service Professionals' profiles, enabling
									communication between Consumers and Service Professionals,
									assisting with appointment bookings, helping select a Service
									Professional, and processing payments. Consumers should
									recognize that this facilitation does not equate to a warranty
									regarding the Pro Services. Service Professionals must
									acknowledge that platform usage doesn't guarantee engagement,
									and Consumers must realize that they are directly soliciting
									Pro Services from the Service Professionals themselves.
								</span>
							</p>
							<p>
								<span>
									Service Professionals are considered customers of Liaison and
									are not identified as employees, contractors, consultants,
									joint venturers, partners, or agents. They are responsible for
									their own equipment, job selection, expertise development,
									other platform engagements, and work schedules. Except as
									specifically outlined on the Platform or in this document,
									Liaison does not have control over or the right to dictate the
									services provided by a Service Professional, whether engaged
									by a Consumer or another individual.
								</span>
							</p>
							<p>
								<span>
									Finally, Liaison may acquire reports concerning Service
									Professionals in compliance with applicable laws, possibly
									including criminal convictions or sex offender registration
									histories. Based on the outcomes of such reports, Liaison may
									take actions such as limiting, blocking, suspending,
									deactivating, or terminating a Service Professional's account,
									with or without notice. By being a Service Professional, you
									consent and authorize Liaison to use your personal details,
									like your full name and date of birth, to acquire these
									reports from its vendors. Any material criminal convictions
									occurring after such reports must be reported to Liaison by
									Service Professionals.
								</span>
							</p>
							<h2>
								<strong>Unauthorized Access and Activities</strong>
							</h2>
							<p>
								<span>
									This section applies to all uses and users of our sites and
									services, unless we have specifically authorized an exception
									to a particular term for a particular user in a written
									agreement. We have sole and absolute discretion to authorize
									or deny any exception or exceptions to the terms in this
									section.
								</span>
							</p>
							<p>
								<span>
									To maintain the integrity and functionality of our sites and
									services for its users, access to our sites and services
									and/or activities related to our sites and services that are
									harmful to, inconsistent with or disruptive of our sites and
									services and/or users beneficial use and enjoyment of our
									sites and services are expressly unauthorized and prohibited.
									For example, without limitation:
								</span>
							</p>
							<ul>
								<li>
									<span>
										Do not use someone else's Account, or provide false
										representations of yourself, Pro Services provided via the
										Platform, your identity or qualifications. Additionally, do
										not present misleading information about a project or other
										details in a quote request, or post Content in categories or
										areas on the Platform that are inappropriate or not
										relevant.
									</span>
								</li>
								<li>
									<span>
										The collection of our sites and service users personal
										information (including but not limited to email addresses,
										IP addresses and telephone numbers) is not allowed for any
										purpose.
									</span>
								</li>
								<li>
									<span>
										Any copying, aggregation, display, distribution, performance
										or derivative use of our sites and services or any content
										posted on our sites and services whether done directly or
										through intermediaries (including but not limited to by
										means of spiders, robots, crawlers, scrapers, framing,
										iframes or RSS feeds) is prohibited. As a limited exception,
										general purpose Internet search engines and noncommercial
										public archives will be entitled to access our sites and
										services without individual written agreements executed with
										us that specifically authorize an exception to this
										prohibition if, in all cases and individual instances: (a)
										they provide a direct hyperlink to the relevant website,
										service, forum or content; (b) they access our sites and
										services from a stable IP address using an easily
										identifiable agent; and (c) they comply with our robots.txt
										file; provided however, we may terminate this limited
										exception as to any search engine or public archive (or any
										person or entity relying on this provision to access our
										sites and services without their own written agreement
										executed with us), at any time and in our sole discretion,
										upon written notice, including, without limitation, by email
										notice.
									</span>
								</li>
								<li>
									<span>
										Any access to or use of our sites and services to design,
										develop, test, update, operate, modify, maintain, support,
										market, advertise, distribute or otherwise make available
										any program, application or service (including, without
										limitation, any device, technology, product, computer
										program, mobile device application, website, or mechanical
										or personal service) that enables or provides access to, use
										of, operation of or interoperation with our sites and
										services (including, without limitation, to access content,
										post content, cross-post content, re-post content, respond
										or reply to content, verify content, transmit content,
										create accounts, verify accounts, use accounts, circumvent
										and/or automate technological security measures or
										restrictions, or flag content) is prohibited. This
										prohibition specifically applies but is not limited to
										software, programs, applications and services for use or
										operation on or by any computer and/or any electronic,
										wireless and/or mobile device, technology or product that
										exists now or in the future.
									</span>
								</li>
								<li>
									<span>
										Any effort to decompile, disassemble or reverse engineer all
										or any part of our sites and services in order to identify,
										acquire, copy or emulate any source code or object code is
										expressly prohibited.
									</span>
								</li>
								<li>
									<span>
										Any activities (including but not limited to posting
										voluminous content) that are inconsistent with use of our
										sites and services in compliance with these TOU or that may
										impair or interfere with the integrity, functionality,
										performance, usefulness, usability, signal-to-noise ratio or
										quality of all or any part of our sites and services in any
										manner are expressly prohibited.
									</span>
								</li>
								<li>
									<span>
										Any attempt (whether or not successful) to engage in, or to
										enable, induce, encourage, cause or assist anyone else to
										engage in, any of the above unauthorized and prohibited
										access and activities is also expressly prohibited and is a
										violation of these TOU.
									</span>
								</li>
								<li>
									<span>
										Do not engage in any actions that breach applicable laws or
										regulations.
									</span>
								</li>
								<li>
									<span>Avoid taking any actions that:</span>
								</li>
								<ul>
									<li>
										<span>
											Could unduly burden the Platform's infrastructure;
										</span>
									</li>
									<li>
										<span>
											Interfere with or attempt to hinder the correct
											functioning of the Platform, or any third-party's ability
											to participate;
										</span>
									</li>
									<li>
										<span>
											Evade measures implemented to limit or bar access to the
											Platform;
										</span>
									</li>
									<li>
										<span>
											Bypass, disable, or in any other manner disrupt the
											Platform's security features;
										</span>
									</li>
									<li>
										<span>
											Spread viruses or other harmful technologies that might
											damage Liaison or its Users;
										</span>
									</li>
									<li>
										<span>
											Utilize the Platform in a manner that infringes on any
											third-party's copyrights, trade secrets, or other rights,
											including rights related to privacy or publicity;
										</span>
									</li>
									<li>
										<span>
											Skirt or manipulate the Fee structure, the billing
											process, or Fees that are due.
										</span>
									</li>
								</ul>
								<li>
									<span>
										Do not ignore a User's requests (including those conveyed by
										Liaison on their behalf) to cease receiving phone calls,
										text messages, emails, or any other communications from you;
									</span>
								</li>
								<li>
									<span>
										Avoid recruiting, soliciting, or contacting Service
										Professionals or Consumers in any manner for employment or
										other purposes that are not specifically intended by the
										Platform;
									</span>
								</li>
								<li>
									<span>
										Do not advertise or solicit a Pro Service on the Platform
										that is unrelated or inappropriate, including, but not
										limited to, any Pro Service that:
									</span>
								</li>
								<ul>
									<li>
										<span>
											Falls outside the supported categories or offers products
											only;
										</span>
									</li>
									<li>
										<span>Provides directories or referrals;</span>
									</li>
									<li>
										<span>Engages in lending;</span>
									</li>
									<li>
										<span>Rents office space;</span>
									</li>
									<li>
										<span>
											Promotes events like parties or professional conventions;
										</span>
									</li>
									<li>
										<span>Competes directly with Liaison's business;</span>
									</li>
									<li>
										<span>Operates outside the United States;</span>
									</li>
									<li>
										<span>
											Involves or promotes Ponzi schemes, junk mail, spam, chain
											letters, pyramid schemes, affiliate marketing, unsolicited
											commercial content, discount cards, credit counseling,
											online surveys, contests, raffles, prizes, bonuses, games
											of chance, or giveaways;
										</span>
									</li>
									<li>
										<span>
											Offers a Pro Service that is not reasonably accessible to
											a Consumer or other individual in their location.
										</span>
									</li>
								</ul>
								<li>
									<span>
										Refrain from engaging in any inappropriate or unlawful
										actions, including submitting content to or through the
										Platform that may be considered harassing, hateful, illegal,
										obscene, defamatory, threatening, profane, or
										discriminatory. This includes content that supports,
										promotes, or encourages actions that could be viewed as
										criminal offenses, activities that could lead to civil
										liabilities, or behaviors that violate any law;
									</span>
								</li>
								<li>
									<span>
										Avoid actions that might diminish the effectiveness or
										validity of the Platform's reviews or rating systems;
									</span>
								</li>
								<li>
									<span>
										Do not fail to carry out Pro Services purchased from you as
										agreed, except in cases where the relevant Consumer has not
										fulfilled a significant term of the agreement for such Pro
										Services (such as refusing to pay);
									</span>
								</li>
								<li>
									<span>
										Refrain from attempting to charge a Consumer for Pro
										Services if payment has already been made or is arranged to
										be made through Liaison;
									</span>
								</li>
								<li>
									<span>
										Do not engage in fraudulent activities, including, but not
										limited to, proposing to make money transfers with the
										intention to ask for a refund of any part of the payment or
										encouraging Users to send cash or use payment methods that
										Liaison prohibits;
									</span>
								</li>
								<li>
									<span>
										Avoid registering for, negotiating a price for, using, or
										otherwise soliciting a Pro Service with no genuine intention
										of utilizing or paying for the Pro Service;
									</span>
								</li>
								<li>
									<span>
										Do not agree to buy a Pro Service if you fail to meet the
										requirements set by a Service Professional;
									</span>
								</li>
								<li>
									<span>
										Refrain from creating multiple Consumer or Service
										Professional Liaison accounts without obtaining written
										consent from Liaison;
									</span>
								</li>
								<li>
									<span>
										Avoid bypassing or attempting to bypass the payment process
										through the Platform when it is explicitly indicated to you
										as mandatory or initiated by a Consumer;
									</span>
								</li>
							</ul>
							<p>
								<span>
									If you access our sites and services or copy, display,
									distribute, perform or create derivative works from our sites
									and services webpages or our intellectual property in
									violation of these TOU or for purposes inconsistent with these
									TOU, your access, copying, display, distribution, performance
									or derivative work is unauthorized. Circumvention of any
									technological restriction or security measure on our sites and
									services or any provision of these TOU that restricts content,
									conduct, accounts or access is expressly prohibited. For
									purposes of this paragraph, you agree that cached copies of
									our webpages on your computer or computer server constitute
									"copies" under the Copyright Act, 17 U.S.C. &sect; 101. For
									purposes of this paragraph, you further agree that CAPTCHAs
									and telephone verification are "technological measures" that
									effectively control access to copyright-protected components
									and our intellectual property rights pursuant to 17 U.S.C.
									&sect; 1201.
								</span>
							</p>
							<h2>
								<strong>Interactions and Disputes with Others</strong>
							</h2>
							<p>
								<span>
									We and our representatives are not parties to, have no
									involvement or interest in, make no representations or
									warranties as to, and have no responsibility or liability with
									respect to any communications, transactions, interactions,
									disputes or any relations whatsoever between you and any other
									user, person or organization ("your interactions with
									others"). You must conduct any necessary, appropriate, prudent
									or judicious investigation, inquiry, research or due diligence
									with respect to your interactions with others.
								</span>
							</p>
							<p>
								<span>
									We aim to provide tools that enable Users to sort out these
									disputes on their own. However, if a rare situation arises
									where a conflict related to the Platform cannot be settled
									independently, you commit to joining a neutral resolution or
									mediation at Liaison's request. This participation should be
									in good faith, and as much as you can reasonably do so, in a
									process led by Liaison or a neutral third-party mediator or
									arbitrator chosen by Liaison. Despite this, you acknowledge
									and accept that Liaison has no mandatory obligation to get
									involved in or dictate the resolution in any disagreements
									between or among Users or any third party.
								</span>
							</p>
							<p>
								<span>
									The sites or services may provide links to other websites and
									online resources. Because we have no control over such
									websites and resources, you acknowledge and agree that we,
									including our shareholders, affiliates, employees, officers,
									directors, agents, representatives, licensors, suppliers and
									service providers, (collectively, "we") are not responsible
									for the availability of such external websites or resources
									and we neither endorse nor are responsible or liable for, and
									make no representations or warranties regarding, the identity
									or trustworthiness of the third-party website or resources,
									including any content, advertising, products, services, or
									other materials on or available through such websites or
									resources. Other websites may provide links to our sites with
									or without authorization. You acknowledge and agree that we do
									not endorse such websites, and are not and shall not be
									responsible or liable for any links from those websites to our
									sites, any content, advertising, products or other materials
									available on or through such other websites, or any loss or
									damages incurred in connection therewith. YOUR USE OF THIRD
									PARTY WEBSITES AND RESOURCES, INCLUDING WITHOUT LIMITATION,
									YOUR USE OF ANY CONTENT, INFORMATION, DATA, ADVERTISING,
									PRODUCTS OR OTHER MATERIALS ON OR AVAILABLE THROUGH SUCH
									WEBSITES AND RESOURCES, IS AT YOUR OWN RISK AND IS SUBJECT TO
									THE TERMS AND CONDITIONS OF USE AND PRIVACY POLICY APPLICABLE
									TO SUCH WEBSITES AND RESOURCES. We shall have the right, at
									any time and in our sole discretion, to block links to our
									sites through technological or other means without prior
									notice.
								</span>
							</p>
							<h2>
								<strong>Fees</strong>
							</h2>
							<p>
								<span>
									In certain instances, we may charge a fee to post content or
									for other features, products, services or licenses. You are
									responsible for any fees applicable to content that you post
									or other features, products, services or licenses you purchase
									or that are purchased through your account. You authorize us
									or our designated payment processor to charge your specified
									credit card, debit card or other payment method for such fees.
								</span>
							</p>
							<p>
								<span>
									Unless otherwise specified, all fees are in United States
									dollars and all charges will be made in United States dollars.
									Any applicable sales or other taxes are additional to the
									stated fee. Currency exchange settlements and foreign
									transaction fees are based on your agreement with your credit
									card or other payment method provider.
								</span>
							</p>
							<p>
								<span>
									Except as required by law or otherwise stated on the site or
									in the services, all fees are nonrefundable and payments and
									purchases may not be canceled by the user. However, we reserve
									the right to refuse or terminate any purchase or attempted
									purchase at any time in our sole discretion.
								</span>
							</p>
							<h2>
								<strong>Indemnification</strong>
							</h2>
							<p>
								<span>
									You agree to indemnify and hold us and our representatives
									harmless from and against any third-party claim, cause of
									action, demand or damages related to or arising out of: (a)
									content that you post or transmit (including but not limited
									to content that a third-party deems defamatory or otherwise
									harmful or offensive); (b) activity that occurs through or by
									use of your account (including, without limitation, all
									content posted or transmitted and your interactions with
									others); (c) your use of or reliance on any user content; and
									(d) your violation of these TOU. This indemnification
									obligation includes payment of any attorneys' fees and costs
									incurred by us or our representatives. We reserve the right,
									at our own expense, to assume the exclusive defense and
									control of any matter otherwise subject to indemnification by
									you, and you agree to cooperate with our defense of these
									claims.
								</span>
							</p>
							<h2>
								<strong>Disclaimers</strong>
							</h2>
							<p>
								<span>
									YOUR ACCESS TO, USE OF AND RELIANCE ON OUR SITES AND SERVICES
									AND CONTENT ACCESSED THROUGH OUR SITES AND SERVICES IS
									ENTIRELY AT YOUR OWN RISK. OUR SITES AND SERVICES (INCLUDING,
									WITHOUT LIMITATION, THE WEBSITES, PROGRAMS, SERVICES, FORUMS
									AND CONTENT ACCESSED THROUGH THE WEBSITES, PROGRAMS, SERVICES
									AND FORUMS) IS PROVIDED ON AN "AS IS" OR "AS AVAILABLE" BASIS
									WITHOUT ANY WARRANTIES OF ANY KIND.
								</span>
							</p>
							<p>
								<span>
									ALL EXPRESS AND IMPLIED WARRANTIES (INCLUDING, WITHOUT
									LIMITATION, WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
									PARTICULAR PURPOSE, AND NON-INFRINGEMENT OF PROPRIETARY
									RIGHTS) ARE EXPRESSLY DISCLAIMED.
								</span>
							</p>
							<p>
								<span>
									WITHOUT LIMITING THE FOREGOING, WE ALSO DISCLAIM ALL
									WARRANTIES FOR OR WITH RESPECT TO: (A) THE SECURITY,
									RELIABILITY, TIMELINESS, ACCURACY AND PERFORMANCE OF OUR SITES
									AND SERVICES AND CONTENT ACCESSED THROUGH OUR SITES AND
									SERVICES; (B) COMPUTER WORMS, VIRUSES, SPYWARE, ADWARE AND ANY
									OTHER MALWARE, MALICIOUS CODE OR HARMFUL CONTENT OR COMPONENTS
									ACCESSED, RECEIVED OR DISSEMINATED THROUGH, RELATED TO OR AS A
									RESULT OF OUR SITES AND SERVICES OR CONTENT ACCESSED THROUGH
									OUR SITES AND SERVICES; AND/OR (C) ANY TRANSACTIONS OR
									POTENTIAL TRANSACTIONS, GOODS OR SERVICES PROMISED OR
									EXCHANGED, INFORMATION OR ADVICE OFFERED OR EXCHANGED, OR
									OTHER CONTENT, INTERACTIONS, REPRESENTATIONS OR COMMUNICATIONS
									THROUGH, RELATED TO OR AS A RESULT OF USE OF OUR SITES AND
									SERVICES OR CONTENT ACCESSED THROUGH OUR SITES AND SERVICES
									(INCLUDING, WITHOUT LIMITATION, ACCESSED THROUGH ANY LINKS ON
									OUR SITES AND SERVICES OR IN CONTENT).
								</span>
							</p>
							<p>
								<span>
									YOU ACKNOWLEDGE AND AGREE THAT LIAISON DOES NOT HAVE AN
									OBLIGATION, BUT RESERVES THE RIGHT FOR ANY REASON, TO (A)
									MONITOR OR REVIEW USER CONTENT; OR (B) FOR ANY PERMISSIBLE
									PURPOSE, CONDUCT IDENTITY VERIFICATION, BACKGROUND (INCLUDING
									CRIMINAL BACKGROUND) OR REGISTERED SEX OFFENDER CHECKS ON ANY
									USER, INCLUDING BUT NOT LIMITED TO SERVICE PROFESSIONALS AND
									CONSUMERS.
								</span>
							</p>
							<p>
								<span>
									NOTWITHSTANDING THE PREVIOUS STATEMENTS, LIAISON, ALONG WITH
									ITS AFFILIATES AND SUBSIDIARIES, AS WELL AS RESPECTIVE
									OFFICERS, DIRECTORS, EMPLOYEES, AND AGENTS, EXPRESSLY RENOUNCE
									ALL WARRANTIES. THIS INCLUDES, BUT IS NOT LIMITED TO, ANY
									WARRANTIES OF MERCHANTABILITY, APPROPRIATENESS FOR A SPECIFIC
									USE, UNDISTURBED ENJOYMENT, OR NON-INFRINGEMENT. FURTHERMORE,
									ANY WARRANTIES THAT MAY HAVE DEVELOPED THROUGH REGULAR
									CONDUCT, DEALING, OR TRADE USAGE; ANY PROMISES, GUARANTEES, OR
									ASSERTIONS RELATED TO THIS PLATFORM OR THE PRO SERVICES
									PROVIDED ON OR VIA THIS PLATFORM; AND ANY WARRANTIES
									CONCERNING THE INTEGRITY, RELEVANCE, VERACITY, PRECISION, OR
									COMPREHENSIVENESS OF ANY DATA OR MATERIAL ON THE PLATFORM,
									INCLUDING ALL COLLECTIVE CONTENT, ARE EXPLICITLY DISCLAIMED.
									LIAISON DOES NOT GUARANTEE THAT THE PLATFORM OR PROFESSIONAL
									SERVICES (PRO SERVICES) WILL ALIGN WITH YOUR SPECIFIC NEEDS,
									NOR WILL THEY BE UNINTERRUPTED, SECURE, OR WITHOUT ERRORS. NO
									RESPONSIBILITY IS ASSUMED BY LIAISON FOR ANY HARM TO YOUR
									COMPUTER OR OTHER POSSESSIONS RESULTING FROM YOUR USE OF THE
									PLATFORM. FURTHERMORE, LIAISON WILL NOT BE HELD ACCOUNTABLE
									FOR ANY LOSS OR HARM OF ANY SORT STEMMING FROM THE UTILIZATION
									OF ANY DATA, CONTENT, OR MATERIALS MADE AVAILABLE VIA THE
									PLATFORM. THIS INCLUDES DEFAMATORY, OFFENSIVE, OR ILLEGAL
									BEHAVIOR BY THIRD PARTIES. NO ASSURANCE IS GIVEN, AND NOTHING
									SAID OR WRITTEN BY LIAISON OR THROUGH THE PLATFORM WILL
									ESTABLISH A WARRANTY NOT CLEARLY STATED HEREIN.
								</span>
							</p>
							<p>
								<span>
									AS A USER OF THE PLATFORM, YOU ARE EXCLUSIVELY RESPONSIBLE FOR
									ALL COMMUNICATIONS AND ENGAGEMENTS WITH OTHER USERS OR PEOPLE
									YOU COME INTO CONTACT WITH AS A RESULT OF USING THE PLATFORM.
									THIS RESPONSIBILITY ENCOMPASSES INTERACTIONS WITH CONSUMERS,
									SERVICE PROFESSIONALS, OR RECIPIENTS OF SERVICES. LIAISON
									NEITHER ATTEMPTS TO AUTHENTICATE THE STATEMENTS OF PLATFORM
									USERS NOR SCRUTINIZES OR EVALUATES ANY PRO SERVICES. THERE ARE
									NO WARRANTIES OR REPRESENTATIONS MADE BY LIAISON CONCERNING
									THE BEHAVIOR OF PLATFORM USERS OR THEIR COMPATIBILITY WITH
									CURRENT OR FUTURE USERS. IF YOU CHOOSE TO MEET IN PERSON OR
									OFFLINE, OR IF YOU PROVIDE OR RECEIVE PRO SERVICES, YOU AGREE
									TO EXERCISE REASONABLE CARE IN ALL DEALINGS AND COMMUNICATIONS
									WITH OTHER PLATFORM USERS AND INDIVIDUALS. LIAISON
									CATEGORICALLY RENOUNCES ALL LIABILITY FOR ANY ACTS OR FAILURES
									BY ANY USERS OR THIRD PARTIES.
								</span>
							</p>
							<p>
								<span>
									LASTLY, LIAISON MAY GIVE PHONE NUMBERS AND EMAILS PROVIDED BY
									CONSUMERS TO SERVICE PROFESSIONALS IN RELATION TO A REQUEST.
									HOWEVER, THESE NUMBERS ARE UNVERIFIED, AND LIAISON DOES NOT
									ASSURE OR REPRESENT THEIR ACCURACY.
								</span>
							</p>
							<p>
								<span>
									THESE DISCLAIMERS WILL APPLY TO THE FULLEST EXTENT PERMITTED
									BY LAW. Some jurisdictions do not allow disclaimer of implied
									warranties. In such jurisdictions, some of the foregoing
									disclaimers as to implied warranties may not apply.
								</span>
							</p>
							<h2>
								<strong>Limitations of Liability</strong>
							</h2>
							<p>
								<span>
									YOU RECOGNIZE AND CONSENT THAT, IN ACCORDANCE WITH THE FULLEST
									EXTENT ALLOWED BY LAW, ANY RISKS STEMMING FROM YOUR
									INTERACTION WITH AND UTILIZATION OF THE PLATFORM AND
									COLLECTIVE CONTENT, AS WELL AS YOUR ENGAGEMENT IN OFFERING OR
									RECEIVING PRO SERVICES VIA THE PLATFORM OR YOUR REQUESTS FOR
									SUCH SERVICES, AND ANY CONTACT YOU MAY HAVE WITH OTHER LIAISON
									USERS OR THIRD-PARTIES, WHETHER ONLINE OR IN PERSON, ARE
									ENTIRELY YOUR RESPONSIBILITY. WE AND OUR REPRESENTATIVES WILL
									UNDER NO CIRCUMSTANCES BE LIABLE FOR ANY ACCESS TO, USE OF OR
									RELIANCE ON OUR SITES AND SERVICES OR CONTENT ACCESSED THROUGH
									OUR SITES AND SERVICES BY YOU OR ANYONE ELSE, OR FOR ANY
									TRANSACTIONS, COMMUNICATIONS, INTERACTIONS, DISPUTES OR
									RELATIONS BETWEEN YOU AND ANY OTHER PERSON OR ORGANIZATION
									ARISING OUT OF OR RELATED TO OUR SITES AND SERVICES OR CONTENT
									ACCESSED THROUGH OUR SITES AND SERVICES, INCLUDING BUT NOT
									LIMITED TO LIABILITY FOR INJUNCTIVE RELIEF AS WELL AS FOR ANY
									HARM, INJURY, LOSS OR DAMAGES OF ANY KIND INCURRED BY YOU OR
									ANYONE ELSE (INCLUDING, WITHOUT LIMITATION, DIRECT, INDIRECT,
									INCIDENTAL, SPECIAL, CONSEQUENTIAL, STATUTORY, EXEMPLARY OR
									PUNITIVE DAMAGES, EVEN IF WE OR OUR REPRESENTATIVE HAS BEEN
									ADVISED OF THE POSSIBILITY OF SUCH DAMAGES). THIS LIMITATION
									OF LIABILITY APPLIES REGARDLESS OF, BUT IS NOT RESTRICTED TO,
									WHETHER THE ALLEGED LIABILITY, HARM, INJURY, LOSS OR DAMAGES
									AROSE FROM AUTHORIZED OR UNAUTHORIZED ACCESS TO OR USE OF OUR
									SITES AND SERVICES OR CONTENT ACCESSED THROUGH OUR SITES AND
									SERVICES; ANY INABILITY TO ACCESS OR USE OUR SITES AND
									SERVICES OR CONTENT ACCESSED THROUGH OUR SITES AND SERVICES,
									OR ANY REMOVAL, DELETION, LIMITATION, MODIFICATION,
									INTERRUPTION, SUSPENSION, DISCONTINUANCE OR TERMINATION OF OUR
									SITES AND SERVICES OR CONTENT ACCESSED THROUGH OUR SITES AND
									SERVICES. NOTHING IN THESE TOU WILL AFFECT THE STATUTORY
									RIGHTS OF ANY CONSUMER.
								</span>
							</p>
							<p>
								<span>
									THESE LIMITATIONS WILL ALSO APPLY WITH RESPECT TO DAMAGES
									RESULTING FROM ANY TRANSACTIONS OR POTENTIAL TRANSACTIONS,
									GOODS OR SERVICES PROMISED OR EXCHANGED, INFORMATION OR ADVICE
									OFFERED OR EXCHANGED, OR OTHER CONTENT, INTERACTIONS,
									REPRESENTATIONS, COMMUNICATIONS OR RELATIONS THROUGH, RELATED
									TO OR AS A RESULT OF OUR SITES AND SERVICES OR CONTENT
									ACCESSED THROUGH OUR SITES AND SERVICES (INCLUDING, WITHOUT
									LIMITATION, ANY LINKS ON OUR SITES AND SERVICES AND LINKS IN
									CONTENT ACCESSED THROUGH OUR SITES AND SERVICES).
								</span>
							</p>
							<p>
								<span>
									IN NO EVENT WILL OUR OR OUR REPRESENTATIVES LIABILITY IN
									CONNECTION WITH ACCESS TO, USE OF OR RELIANCE ON OUR SITES AND
									SERVICES OR CONTENT ACCESSED THROUGH OUR SITES AND SERVICES BY
									YOU EXCEED THE AMOUNTS PAID BY YOU TO US, IF ANY. TOTAL
									AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THIS
									AGREEMENT WILL NOT EXCEED THE AMOUNTS PAID BY YOU DURING THE
									SIX (6) MONTHS PRECEDING THE BRINGING OF ANY CLAIM, OR FIVE
									HUNDRED DOLLARS ($500.00), WHICHEVER IS LESS. YOU ACKNOWLEDGE
									AND AGREE THAT IF YOU HAVE NOT PAID PROVIDER ANY AMOUNTS IN
									THE SIX (6) MONTHS PRECEDING THE BRINGING OF ANY CLAIM, YOUR
									SOLE AND EXCLUSIVE REMEDY FOR ANY DISPUTE IS TO STOP USING OUR
									SITES AND SERVICES AND TO CANCEL YOUR ACCOUNT, IF ANY.
								</span>
							</p>
							<p>
								<span>
									You hereby release us and each of our representatives, and
									their respective subsidiaries, affiliates, successors,
									predecessors, assigns, heirs, service providers and suppliers,
									from all claims, demands and damages of every kind and nature,
									known and unknown, direct and indirect, suspected and
									unsuspected, disclosed and undisclosed, arising out of or in
									any way related to our sites and services or content accessed
									through our sites and services, or any interactions with
									others arising out of or related to our sites and services or
									content accessed through our sites and services, and you
									expressly waive the provisions of California Civil Code
									Section 1542 (and any similar laws in other jurisdictions),
									which provides: "A general release does not extend to claims
									which the creditor does not know or suspect to exist in his
									favor at the time of executing the release, which, if known by
									him must have materially affected his settlement with the
									debtor."
								</span>
							</p>
							<p>
								<span>
									THESE LIMITATIONS WILL APPLY TO THE FULLEST EXTENT PERMITTED
									BY LAW.
								</span>
							</p>
							<h2>
								<strong>Damages</strong>
							</h2>
							<p>
								<span>
									At our election, we may seek actual or liquidated damages. In
									addition to any injunctive relief, you agree to pay to us the
									total amount of all actual damages (including but not limited
									to direct, indirect, consequential and incidental damages)
									caused by any violation of these TOU for which you bear
									responsibility; except you acknowledge that, for certain TOU
									violations, actual damages would be extremely difficult or
									impossible to quantify. Consequently, for such TOU violations,
									you agree to pay liquidated damages to us as described in our
									liquidated damages policy, which can be found{" "}
								</span>
								<a href="/terms-of-service/terms-damages">
									<span>here</span>
								</a>
								<span>.</span>
							</p>
							<p>
								<span>
									Furthermore, you agree that the amounts of liquidated damages
									described therein are reasonable estimates of our damages for
									such violations, and that liquidated damages for violations of
									these TOU are and will be cumulative.
								</span>
							</p>
							<h2>
								<strong>Injunctive Relief</strong>
							</h2>
							<p>
								<span>
									You acknowledge and agree that any violation or breach of
									these TOU may cause us immediate and irreparable harm and
									damages. Consequently, notwithstanding any other provision of
									these TOU or other applicable legal requirements, we have the
									right to, and may in our discretion, immediately obtain
									preliminary injunctive relief (including, without limitation,
									temporary restraining orders) and seek permanent injunctive
									relief regarding any violation or breach of these TOU. In
									addition to any and all other remedies available to us in law
									or in equity, we may seek specific performance of any term in
									these TOU, including but not limited to by preliminary or
									permanent injunction.
								</span>
							</p>
							<h2>
								<strong>Release of Information</strong>
							</h2>
							<p>
								<span>Our </span>
								<a href="/privacy-policy">
									<span>Privacy Policy</span>
								</a>
								<span>
									{" "}
									prohibits the release of user or account information except in
									limited circumstances, including with express permission from
									the user, as and when required or permitted by law, or to
									comply with legal process properly served on us. If you seek
									the identity or account information of a user of our sites and
									services in connection with a civil legal matter, you must{" "}
								</span>
								<a href={LINK_HELP_CONTACT}>
									<span>serve us</span>
								</a>
								<span> with a valid subpoena.</span>
							</p>
							<p>
								<span>
									We reserve the right to disclose any personal information
									about you or your use of our sites and services, including its
									contents, without your prior permission if we have a good
									faith belief that such action is necessary to: (1) conform to
									legal requirements or comply with legal process; (2) protect
									and defend our rights and property or our affiliated
									companies; (3) enforce these TOU; or (4) act to protect the
									interests of our users or others. Our performance of these TOU
									is subject to existing laws and legal process, and nothing
									contained in this TOU is in derogation of our right to comply
									with governmental, court and law enforcement requests or
									requirements relating to your use of our sites and services or
									information provided to or gathered by us with respect to such
									use.
								</span>
							</p>
							<p>
								<strong>
									Notice to Users; Response Time; User Objections:
								</strong>
								<span>
									&nbsp; Upon receipt of a valid civil subpoena, we will
									promptly notify the user whose information is sought via
									email.&nbsp; If circumstances do not amount to an emergency,
									we will not immediately produce the user information sought by
									the subpoena and will provide the user an opportunity to move
									to quash the subpoena in court. Users should consult with an
									attorney should they object to the disclosure of their
									information. We will disclose the information requested by the
									subpoena or legal request unless we receive a copy of a
									request for court order that we not do so no later than noon
									on the day that is two days before our compliance with the
									request is due.
								</span>
							</p>
							<h2>
								<strong>Copyright Policy</strong>
							</h2>
							<p>
								<span>
									In accordance with the Digital Millennium Copyright Act of
									1998 (&ldquo;DMCA&rdquo;), the text of which can be found on
									the U.S. Copyright Office website at:{" "}
								</span>
								<a href="http://www.copyright.gov/legislation/dmca.pdf">
									<span>http://www.copyright.gov/legislation/dmca.pdf</span>
								</a>
								<span>
									, we will respond expeditiously to claims of copyright
									infringement committed using our sites and services that are
									properly reported to our Copyright Agent identified below.
								</span>
							</p>
							<p>
								<span>
									If you are a copyright owner, or are authorized to act on
									behalf of one, or authorized to act under any exclusive right
									under copyright, please report alleged copyright infringements
									taking place on or through our sites or services by sending a
									DMCA notice and delivering it to our Copyright Agent. Upon
									receipt of the notice as described below, we will take
									whatever action, in our sole discretion, we deem appropriate,
									including removal of the challenged material from our site or
									service. The notice must:
								</span>
							</p>
							<ul>
								<li>
									<span>
										Identify the copyrighted work that you claim has been
										infringed or, if multiple copyrighted works are covered by
										the notice, you may provide a representative list of the
										copyrighted works that you claim have been infringed;
									</span>
								</li>
								<li>
									<span>
										Identify (i) the material that you claim is infringing (or
										to be the subject of infringing activity) that is to be
										removed or access to which is to be disabled, and
										information reasonably sufficient to permit us to locate the
										material, including at a minimum, if applicable, the URL of
										the link shown on the site where such material may be found,
										and (ii) the reference or link to the material or activity
										that you claim to be infringing that is to be removed or
										access to which is to be disabled, and information
										reasonably sufficient to permit us to locate that reference
										or link, including at a minimum, if applicable, the URL of
										the link shown on the site where such reference or link may
										be found;
									</span>
								</li>
								<li>
									<span>
										Provide your mailing address, telephone number and, if
										available, email address;
									</span>
								</li>
								<li>
									<span>
										Include both of the following statements in the body of the
										notice:
									</span>
								</li>
								<ul>
									<li>
										<span>
											"I hereby state that I have a good faith belief that the
											disputed use of the copyrighted material or reference or
											link to such material is not authorized by the copyright
											owner, its agent, or the law (e.g., as a fair use)."
										</span>
									</li>
									<li>
										<span>
											"I hereby state that the information in this Notice is
											accurate and, under penalty of perjury, that I am the
											owner, or authorized to act on behalf of the owner, of the
											copyright or of an exclusive right under the copyright
											that is allegedly infringed."
										</span>
									</li>
								</ul>
								<li>
									<span>
										Provide your full legal name and your physical or electronic
										signature
									</span>
								</li>
							</ul>
							<p>
								<a href={LINK_HELP_CONTACT}>
									<span>Email us</span>
								</a>
								<span>
									{" "}
									this notice, with all items completed, to our Copyright Agent
									with the subject line &ldquo;DMCA Complaint&rdquo;. You
									acknowledge if you fail to comply with all of the above
									requirements, your DMCA notice may not be valid.
								</span>
							</p>
							<p>
								<span>
									In appropriate circumstances and at our sole discretion, we
									may disable and/or terminate the accounts of users who
									repeatedly infringe or are repeatedly charged with infringing
									the copyrights or other intellectual property rights of
									others.
								</span>
							</p>
							<h2>
								<strong>Privacy</strong>
							</h2>
							<p>
								<span>
									We have established a privacy policy covering the collection,
									use, and disclosure of user information, which can be found{" "}
								</span>
								<a href="/privacy-policy">
									<span>here</span>
								</a>
								<span>.</span>
							</p>

							<h2>
								<strong>Free and Paid Services</strong>
							</h2>

							<p>
								We offer a mix of free and paid services. For paid services, we
								can process payments through your linked debit or credit card,
								or directly from your transaction proceeds, Liaison-account
								balance, or linked bank account.
							</p>
							<p>
								If there are changes to our subscription fees, we'll notify you
								30 days in advance. You have the option to cancel your
								subscription at any time.
							</p>
							<p>
								Liaison provides both free Services, which do not incur
								additional fees ("Free Services"), and paid-for Services ("Paid
								Services"). Our Paid Services include those that require payment
								on a recurring basis ("Subscription Services") and others that
								are billed based on usage ("A La Carte Services"). When you sign
								up for a Subscription Service, including after any trial period,
								you agree to pay the recurring subscription fee along with any
								applicable taxes ("Subscription Fee"). A La Carte Services are
								billed based on usage or volume, and by using them, you agree to
								pay the fees and taxes incurred at the time of service ("A La
								Carte Fees"). Together, these are referred to as "Paid Service
								Fees." For further details, please refer to our Payment Terms.
							</p>
							<p>
								Generally, Paid Service Fees can be settled via debit or credit
								card, or deducted from your transaction proceeds. Note, however,
								that payments for hardware-related services can only be made
								through debit or credit card. By linking a debit or credit card
								to your account, you authorize us to collect any Paid Service
								Fees by charging your card or deducting them from your account.
								We also reserve the right to collect Paid Service Fees by
								drawing from your transaction proceeds, your account balance, or
								a linked bank account.
							</p>
							<p>
								Subscription Fees are typically charged on the first of every
								month until the subscription is canceled, which you can do at
								any time via your Liaison Account settings. If you cancel,
								you'll retain access to the Subscription Service until the end
								of the current billing period, but you won't receive a refund
								for any charges already incurred. We may modify our Subscription
								Fee with thirty days' advance notice. Your continued use of the
								Subscription Services following such notice will indicate your
								acceptance of the new fee structure.
							</p>

							<h2>
								<strong>Taxes</strong>
							</h2>
							<p>
								You are responsible for your own taxes. However, under certain
								laws, we may need to charge, remit, or report taxes related to
								Paid Services and provide specific information about you to tax
								authorities like the IRS.
							</p>
							<p>
								The term "Tax" and "Taxes" refer to all current and future
								taxes, charges, fees, levies, or other assessments, including,
								but not limited to, income, telecommunications, value-added,
								goods and services taxes, stamp taxes or duties, and various
								other forms including excise, property, sales, withholding, and
								payroll taxes, imposed by any tax authority, domestic or
								foreign. This includes any penalties, interest, or additions
								related to these taxes.
							</p>
							<p>
								Unless explicitly stated, all fees for Paid Services do not
								include any Taxes. You are responsible for identifying,
								calculating, collecting, and remitting all necessary Taxes
								related to your use of our Services. This responsibility extends
								to determining whether Taxes apply to your transactions,
								registering with the appropriate tax authorities where required,
								and handling all related tax obligations.
							</p>
							<p>
								Liaison disclaims any liability for such Taxes, and you agree to
								indemnify, defend, and hold Liaison harmless against any such
								Taxes and associated costs. It's important to note that we are
								not considered a marketplace facilitator or provider under any
								relevant tax laws, and you agree not to treat us as such in any
								tax filings or assessments.
							</p>
							<p>
								In cases where we are required by law to charge Taxes on our
								Services, you must pay these unless you provide us with
								sufficient documentation to prove that you are exempt. Failure
								to provide accurate exemption documentation may result in your
								being liable for these Taxes, and you agree to indemnify and
								defend Liaison against any claims by tax authorities for
								incorrect or uncollected Taxes due to your failure to provide
								necessary documentation.
							</p>
							<p>
								Liaison may need to report certain tax information to
								authorities or provide it to you based on your usage of the
								Services. You must provide necessary information for such
								reporting upon request and update it as required by law or
								during tax audits.
							</p>
							<p>
								Liaison may deduct any applicable withholding Taxes or other
								Taxes from payments to you as required by law and remit these to
								the relevant tax authority on your behalf. Any such deducted
								amounts will be considered as paid to you for all intents and
								purposes under these Terms.
							</p>
							<p>
								Please be aware that Liaison does not provide tax advice. For
								tax-related questions or issues concerning the Services or these
								Terms, you should consult with your own tax or legal advisor.
							</p>

							<h2>
								<strong>Marketplace Budget and fees</strong>
							</h2>
							<p>
								<span>
									Liaison's Platform imposes Fees in relation to its use.
								</span>
							</p>
							<p>
								<span>
									For obtaining specific services on the Platform, including
									receiving contacts, bookings, or payments from Consumers or
									others, Service Professionals may pay Fees to Liaison. If
									Consumers or other individuals contact or book you about a Pro
									Service that aligns with your targeting preferences, Liaison
									will automatically charge the payment method stored on your
									account. Fees might also be charged to your stored payment
									method or deducted from your Liaison balance for other
									reasons, such as cancellation fees or specific services based
									on prior agreements. Fees can also be subtracted from the
									total amount that a Consumer pays for a particular Pro
									Service. You must keep at least one valid payment method on
									file to use Liaison, in accordance with our Stored Payment
									Terms and Conditions. You may also need to establish a weekly
									spending limit or Budget, as detailed below, and except as
									specified in our Refund Policy, all sales and Fees are final
									and non-refundable on Liaison.
								</span>
							</p>
							<p>
								<span>
									As a Service Professional, Liaison may mandate that you
									establish one or more weekly spending limits (referred to as
									"Budgets") for specific Fees over a certain time frame
									("Budget Period"). The types of leads or Fees that apply to
									your Budget will be made known to you when you set it. Liaison
									may charge your stored payment method beyond your Budget for
									Fees not included in your Budget or if you permit Liaison to
									do so. Your Budget isn&rsquo;t a subscription and isn&rsquo;t
									charged upfront. You'll be charged Fees, and the ones covered
									by a Budget will not go over your stated Budget without your
									consent. Although Liaison may provide an estimate of the
									number of Consumers who might contact you, there are no
									guarantees, and actual outcomes may differ.
								</span>
							</p>
							<p>
								<span>
									The duration of the Budget Period is identified when you set
									your Budget. It remains the same within that Budget Period but
									can be altered for future ones. If the length changes, you can
									adjust your Budget, or Liaison will automatically do it for
									you. For example, a one-week $50 Budget will be automatically
									adjusted to $100 for a two-week period if you don't manually
									change it. Changes can be made to your Budget at any time,
									even mid-Budget Period, and if you don't alter it prior to the
									next Budget Period, the existing one will automatically carry
									over.
								</span>
							</p>
							<p>
								<span>
									For Service Professionals using Liaison, charges can happen at
									various points:
								</span>
							</p>
							<p>
								<span>
									If You Are New to Liaison: If you lack sufficient purchasing
									history, your payment method will be charged every time a
									Consumer contacts or books you and your Liaison balance isn't
									sufficient.
								</span>
							</p>
							<p>
								<span>
									If You Have a Sufficient Purchasing History: Liaison may
									periodically charge your payment method for total Fees when
									you are contacted by Consumers. Liaison might adjust the
									frequency of charges, which may not align with the Budget
									Period.
								</span>
							</p>
							<p>
								<span>
									There might also be services with different payment timings.
								</span>
							</p>
							<p>
								<span>
									For typical charges, Liaison will try the default payment
									method first. If unsuccessful, Liaison may attempt other
									associated payment methods. If details change, your provider
									may update us, and we may use the new information to prevent
									Pro Services interruption.
								</span>
							</p>
							<p>
								<span>
									Penalty Fees might be charged by Liaison for issues like
									fraud, misconduct, late payment, or other Term violations.
									Some penalty Fees, like cancellation Fees, are also disclosed
									directly in the Platform.
								</span>
							</p>
							<p>
								<span>
									Regardless of an active Account, you must pay all applicable
									Fees. If unpaid, Liaison has the right to recover payment and
									possibly terminate or suspend your Account. Any communication
									about unpaid Fees will be electronic.
								</span>
							</p>
							<p>
								<span>
									Taxes might be exclusive of the required payments by these
									Terms. Some jurisdictions might require us to collect Taxes in
									connection with the Pro Services, which you will bear. Liaison
									can determine your tax jurisdiction as needed, and you will
									pay taxes to Liaison if they are included in an invoice. You
									also understand that you are responsible for your tax
									obligations and must consult your own tax advisers, as we
									don't provide specific tax advice to either Service
									Professionals or Consumers.
								</span>
							</p>
							<h3>
								<strong>Stored payment terms</strong>
							</h3>
							<p>
								<span>
									When you supply Liaison with your payment method information,
									you are giving consent to Liaison to keep this information as
									your "Stored Payment Method." The complete and full terms of
									the "Liaison Agreements," which include Liaison's Terms of Use
									and Privacy Policy, are applicable to these Terms and
									Conditions. The Liaison Agreements, or any other agreement you
									have made with Liaison, will dictate how your Stored Payment
									Method is used, stored, and disclosed. Any terms that are not
									defined in this context will have the meanings that are
									ascribed to them in the Liaison Agreements.
								</span>
							</p>
							<p>
								<span>
									Your agreement with Liaison regarding the Stored Payment
									Method remains in effect indefinitely unless you ask for the
									deletion of this information. If you request the removal of
									your Stored Payment Method, you will not be able to pay for
									Pro Services or appear in the search results for Pro Services
									on Liaison since all Service Professionals must have a Stored
									Payment Method on their accounts to utilize Liaison. The only
									exception to this would be if you choose to add a new payment
									method to your account.
								</span>
							</p>
							<h2>
								<strong>Advertising and Ads</strong>
							</h2>
							<p>
								<span>
									"Liaison Advertising" or "Liaison Ads" refers to a continuous
									advertising subscription that places you at the forefront of
									Liaison's directory pages, promotes you in search engines and
									social networks, and is available on some sites. When
									consumers look for Service Professionals, explore questions
									asked by other consumers, or read professional articles
									authored by Service Professionals, your advertisement appears
									at the top. We may also advertise your business in Google,
									Facebook, and other major ad platforms. Liaison Advertising
									may provide options for personalizing your ad message,
									displaying various ways to contact you, and showcasing profile
									details not shown in Liaison's standard directory listings.
								</span>
							</p>
							<p>
								<span>
									A tracking phone number may be allocated by Liaison to your
									Liaison Advertising to monitor your analytics.
								</span>
							</p>
							<p>
								<span>
									Your Liaison Advertising will be highlighted for inquiries
									that align with the practice areas and locations you've agreed
									to. The geographic position is defined by the location entered
									during the search and/or any available geographic information
									from where the search started.
								</span>
							</p>
							<p>
								<span>
									We make every effort to fulfill the demand for Liaison
									Advertising, but there might be occasions when advertising in
									your region is fully booked. In such cases, your subscription
									will be backordered until space opens up, and we will process
									backorders on a first-come, first-served principle. This
									backordered subscription will reserve your spot in the
									advertising queue, and your Liaison Advertising subscription
									fee will only be charged once your subscription is active.
								</span>
							</p>
							<h3>
								<strong>Authorization for Advertising</strong>
							</h3>
							<p>
								While your subscription is active, you authorize us to advertise
								on behalf of your business on Google, Facebook, and other
								advertising platforms. We reserve the right to use your business
								name, logo, photos, and any other information about your
								business obtained from your profile in our advertisements. This
								authorization is required to efficiently drive customers to your
								business. You agree to not hold us liable for any claims,
								damages, or losses resulting from or related to such
								advertisements.
							</p>
							<h3>
								<strong>Implied Warranties</strong>
							</h3>
							<p>
								To the maximum extent permitted by law and except for the
								express warranties in this section, Liaison, Inc. provides our
								services on an "as-is" basis. Liaison, Inc. disclaims and makes
								no other representation or warranty of any kind, whether
								express, implied, or statutory, including but not limited to
								warranties of merchantability, title, non-infringement,
								accuracy, absence of omissions, completeness, currentness,
								delays, or fitness for a particular purpose. Neither Liaison,
								Inc. nor its affiliates or agents warrant that the results
								obtained from the use of the Subscriptions will meet your
								requirements, be uninterrupted, timely, secure, or error-free.
							</p>

							<h2>
								<strong>Bookings, Appointments, and Orders</strong>
							</h2>

							<p>
								These Terms of Service govern each booking made through the
								Liaison Platform, including online booking services or ordering
								products.
							</p>
							<p>
								Please review these Terms of Service carefully before using the
								Liaison Appointment Services. We retain the right to modify
								these Terms of Service periodically by updating them on this
								page. Any alterations will be applicable to your subsequent
								Appointment/Order, so it's advisable to check this page
								frequently. If you disagree with any changes, refrain from
								making an Appointment/Order.
							</p>
							<p>
								To the fullest extent allowed by law, Liaison assumes no
								liability or responsibility for the quality, safety, or delivery
								of the products or services provided through the Liaison Booking
								Services or Liaison Store. The responsibility for the services
								offered to clients rests solely with the Partner. Further
								details regarding Liaison 's liability towards the Partner are
								outlined in the Indemnity section of this Agreement.
							</p>
							<p>
								When capitalized words or phrases are used in these Terms of
								Service, they carry specific meanings:
							</p>
							<ul>
								<li>
									"Appointment": Refers to any booking for one or more services
									from a Partner made through the Liaison Platform, including
									updates, rescheduling, or cancellations.
								</li>
								<li>
									"Cancellation Policy": Specifies the conditions under which a
									Partner may charge a fee for a canceled Appointment, as
									outlined in the Partner Terms of Sale.
								</li>
								<li>
									"Client" and "you": Denotes the user of the Liaison Services
									or the purchaser of any Partner Services.
								</li>
								<li>
									"Confirmation": Refers to a written confirmation provided to
									you regarding an Appointment or Order, delivered via email or
									the Liaison Platform.
								</li>
								<li>
									"Deposit Policy": Outlines the conditions under which a
									Partner may request the purchase of a Partner Credit at the
									time of making an Appointment.
								</li>
								<li>
									"Liaison Account": Refers to an account created on the Liaison
									Platform containing personal information, Appointment and
									order history, and contact details.
								</li>
								<li>
									"Liaison Appointment Services": Encompasses all appointment
									booking services provided through the Liaison Platform,
									including creating, updating, rescheduling, and canceling
									appointments.
								</li>
								<li>
									"Liaison Payment Services": Denotes the online and in-app
									payment facility available for select Partners on the Liaison
									Platform.
								</li>
								<li>
									"Liaison Platform": Includes the Liaison website, mobile
									application, and web interface owned and provided by Liaison.
								</li>
								<li>
									"Liaison Services": Encompasses all information,
									recommendations, and/or services provided by Liaison through
									the Liaison Platform, including the Liaison Platform itself,
									Liaison Appointment Services, Liaison Payment Services, and
									Partner Profiles.
								</li>
								<li>
									"No Show Policy": Outlines the conditions under which a
									Partner may charge a fee for a client failing to show up for a
									scheduled Appointment.
								</li>
								<li>
									"Order": Denotes any orders for products from a Partner
									through their store on the Liaison Platform.
								</li>
								<li>
									"Partner Contract": Refers to any contract between you and the
									relevant Partner for their Partner Services booked through the
									Liaison Platform.
								</li>
								<li>
									"Partner Credit": Represents a credit purchased by the Client
									via the Liaison Services for the purpose of providing
									pre-payment to a Partner for a Partner Service.
								</li>
								<li>
									"Partner Profile": Refers to a Partner's webpage(s) on the
									Liaison Platform containing information about their Partner
									Services.
								</li>
								<li>
									"Partner Services": Denotes any products, goods, and/or
									services offered for purchase or booking by a Partner on the
									Liaison Platform.
								</li>
								<li>
									"Partner Terms of Sale": Include the date, time, price,
									Partner Services, discounts, location, and any other terms and
									conditions provided through the Liaison Platform at the time
									an Appointment is made by the Client.
								</li>
								<li>
									"Partner Voucher": Represents a voucher issued by the Partner
									via the Liaison Platform, entitling the voucher holder to
									receive a Partner offer from the Partner, subject to any
									Partner Contract.
								</li>
								<li>
									"Partner": Denotes a selected third-party provider of goods
									and services offering their goods and services for sale on the
									Liaison Platform.
								</li>
								<li>
									"Pay In-Store Service": Refers to a service where an
									Appointment/Order is made on the Liaison Platform, but payment
									is made at the Partner's premises.
								</li>
								<li>
									"Payment Processor": Represents third-party payment processors
									supporting Liaison with the provision of the Liaison Payment
									Services.
								</li>
								<li>
									"Promo Codes": Refers to promotional codes issued by a Partner
									for use when purchasing Partner Services, subject to relevant
									promotion terms.
								</li>
							</ul>
							<h3>Our services</h3>
							<p>
								Liaison operates as a platform connecting users like you with
								our Partners who offer various products and services. Through
								the Liaison Platform, you can schedule Appointments for Partner
								Services or place Orders for Products directly. It's important
								to note that Liaison doesn't own or operate any Partner
								establishments, provide Partner Services, or fulfill Orders for
								Products.
							</p>
							<p>
								When you use the Liaison Services, you're entering into a
								contract with Liaison. However, your contract for the Partner
								Services is solely between you and the Partner offering those
								services.
							</p>
							<p>
								Liaison serves as an intermediary, facilitating the arrangement
								and conclusion of your Appointments/Orders with our Partners.
								When you make a payment for an Appointment/Order through the
								Liaison Platform, we receive the payment as a commercial agent
								on behalf of the respective Partner. This payment discharge your
								debt to the Partner for that particular Appointment/Order.
								Please note that this arrangement doesn't apply to any Pay
								In-Store Service where payment is made directly at the Partner's
								premises.
							</p>
							<p>
								When you use the Liaison Platform to book or order any Partner
								Services or Products, you're also entering into a contract
								directly with the relevant Partner, which includes adhering to
								any Partner Terms of Sale.
							</p>
							<h3>Our partners' services</h3>
							<p>
								The Partner's provision of Partner Services and fulfillment of
								any Appointments/Orders are governed by the Partner Contract you
								establish with them. Liaison is not a party to this contract
								between you and the Partner.
							</p>
							<p>
								Our Partners are obligated to deliver Partner Services as
								outlined in the applicable Partner Contract, including any
								Partner Terms of Sale. We require Partners to ensure that all
								information provided on the Liaison Platform is accurate,
								complete, and not misleading. However, we cannot independently
								verify the information provided by Partners. It's the
								responsibility of each Partner to ensure that their listed
								Partner Services are available and accurately described. Please
								note that the descriptions and/or images of Partner Services on
								the Liaison Platform are for illustrative purposes only, and
								actual services may vary.
							</p>
							<p>
								As a consumer, you have legal rights concerning services that
								are not performed with reasonable care and skill or are not as
								described. These rights are protected by consumer protection
								laws. If you have concerns about the services you receive from a
								Partner, you may seek advice from your local Citizens' Advice
								Bureau or trading standards office. These legal rights are in
								addition to any rights or protections provided by these Terms of
								Service and will not be affected by them.
							</p>
							<h3>Using the booking platform</h3>
							<p>
								To use the Liaison Platform for making Appointments/Orders, you
								have the option to check out as a guest or create a Liaison
								Account by signing up and providing certain information such as
								your name, mobile telephone number, payment details, and a
								password of your choice.
							</p>
							<p>
								It's essential to provide accurate and complete information to
								Liaison and keep it updated through the Liaison Platform. We may
								verify the information you provide and reserve the right to
								refuse the use of Liaison Services or the Liaison Platform if
								inaccurate or incomplete information is provided, without
								specifying reasons.
							</p>
							<p>
								Here are some tips to make the most of your experience with
								Liaison:
							</p>
							<ol>
								<li>
									<p>
										<strong>Contact Partners directly:</strong> Each Partner
										Profile includes their contact information, enabling you to
										communicate directly with them. You can also reach out to
										our support team.
									</p>
								</li>
								<li>
									<p>
										<strong>Read the Partner Contract:</strong> Partners may
										have specific terms regarding deposits, cancellations,
										refunds, taxes, or other matters. Look for links to these
										terms on the Partner Profile and read them carefully.
									</p>
								</li>
								<li>
									<p>
										<strong>Check out safely:</strong> Our Liaison Payment
										Services are designed to ensure a secure online payment
										experience. Look for the "https://" at the beginning of the
										checkout link to confirm its security.
									</p>
								</li>
								<li>
									<p>
										<strong>Research independently:</strong> Check reviews on
										Liaison and other trusted review sites to gauge the quality
										of a Partner's products or services.
									</p>
								</li>
							</ol>
							<p>
								It's your responsibility (or the recipient's responsibility) to
								communicate any medical or health-related conditions or special
								needs to the Partner that may affect or be affected by the
								Partner Services. This includes providing allergy information
								and other health details. Failure to disclose such information
								may result in neither Liaison nor the Partner being liable for
								any resulting injury, loss, or damages that could have been
								avoided with proper disclosure.
							</p>
							<p>
								In connection with your use of Liaison Services, we may send you
								electronic service messages for various reasons, including
								security purposes and updates related to your
								Appointments/Orders. By using Liaison Services, you consent to
								receive automated text messages from Liaison and its Partners at
								the phone number you provided during registration. These
								messages may include promotional content and information about
								your account and Appointments/Orders. You can manage your
								preferences for receiving automated messages within your
								personal profile settings.
							</p>
							<p>
								For more information on how we handle your personal information
								and about promotional and marketing messages, please refer to
								our Privacy Policy.
							</p>
							<h3>How to make an appointment / order&nbsp;</h3>
							<p>
								The Liaison Platform allows you to browse and select the Partner
								Services you wish to receive and proceed to make an
								Appointment/Order for those services. Before confirming your
								Appointment/Order, you have the opportunity to review and
								correct any errors. We ensure that any relevant Partner Terms of
								Sale, including Deposit Policy, Cancellation Policy, or No Show
								Policy, are disclosed to you before you confirm your
								Appointment/Order. It's important to carefully review all
								details of your Appointment/Order and any applicable Partner
								Terms of Sale before confirming.
							</p>
							<p>
								Once you make an Appointment/Order, we, acting as the commercial
								agent of the Partner, will forward your request to the Partner.
								The formation of the Partner Contract occurs when we send you a
								Confirmation. Please note that all Partner Services listed on
								the Liaison Platform are subject to availability, and we reserve
								the right to accept or reject each Appointment/Order on behalf
								of the Partner. Your Confirmation serves as a receipt from
								Liaison and will be sent to the contact information provided in
								your Liaison Account, either via email or SMS, upon confirming
								an Appointment/Order. If you require a tax receipt, you must
								contact the Partner directly for assistance.
							</p>
							<p>
								When you schedule an appointment, it's essential to arrive at
								the Partner's place of business as indicated in the Partner
								Terms of Sale in order to receive the Partner Services.
							</p>
							<h3>Vouchers issued by our Partners</h3>
							<p>
								Partners have the option to issue Partner Vouchers that can be
								redeemed for Partner Services, or they may offer you the
								opportunity to purchase Partner Vouchers for later use. The
								availability and terms of these Partner Vouchers are determined
								by the Partner.
							</p>
							<p>
								If you choose to purchase a Partner Voucher, you will be subject
								to any Partner Terms of Sale provided to you at the time of
								purchase. The provision and redemption of Partner Vouchers are
								governed by the Partner Contract, including any specific terms
								outlined in the Partner Terms of Sale. It's important to note
								that Liaison is not a party to the Partner Contract between you
								and the Partner, and therefore, we are not responsible for
								Partner Vouchers.
							</p>
							<p>
								Unless otherwise specified in the offer terms, the Partner
								reserves the right to withdraw or modify any offer at any time,
								except in cases where you have already placed an order for an
								Appointment/Order based on the offer and we have sent a
								confirmation notice.
							</p>
							<h3>Promo codes issued by our Partners</h3>
							<p>
								Partners have the discretion to issue Promo Codes, which can be
								used by clients when purchasing Partner Services. However,
								Partners reserve the right to withdraw Promo Codes at any time,
								especially if they are used fraudulently, cause technical
								issues, or are tampered with.
							</p>
							<p>
								If a Promo Code is designated as personal to you, it should not
								be shared with any third party. However, if Promo Codes are made
								publicly available, you are permitted to share them with third
								parties. Should the Partner or Liaison reasonably believe that a
								Promo Code has been shared or misused, they reserve the right to
								cancel such Promo Codes.
							</p>
							<p>
								It's important to note that the Partner sets the terms of any
								Promo Codes and is responsible for fulfilling the Partner
								Services associated with them. Liaison does not assume
								responsibility for any Promo Codes issued by our Partners.
							</p>
							<h3>Paying for a Partner service</h3>
							<p>
								Prices for Appointments and Orders are displayed on the Liaison
								Platform, including any delivery or processing charges. However,
								the final price for an Appointment may be adjusted to include
								additional goods or services purchased from the Partner at the
								time of receiving the Partner Services. Partners may also offer
								discounts, which will be reflected in the final amount payable.
							</p>
							<p>
								If you choose to tip the Partner for your Appointment, you'll be
								given the option to do so via a notification on the Liaison
								Platform following your Appointment. Tipping is entirely at your
								discretion and is in addition to the purchase price for the
								Appointment. Liaison collects payment on behalf of the Partner,
								and the tips are considered a direct payment from you to the
								Partner. Your name will be shared with the Partner when the tip
								is notified. The Partner will receive 100% of any tip payment
								you choose to make, subject to payment processing fees.
							</p>
							<p>
								When making payments for Partner services, you agree to provide
								Liaison with a valid payment method and to pay for all Partner
								Services purchased. Payment can be made via the Liaison Payment
								Services or directly with the Partner as a Pay In-Store Service.
							</p>
							<p>
								If you use the Liaison Payment Services, Liaison will charge you
								on behalf of the Partner for the total amount of your
								Appointment/Order, including taxes and additional fees. Your
								payment to Liaison discharges your debt to the Partner for the
								relevant Appointment/Order. Currency conversion costs or other
								charges incurred are borne by you in addition to the payment
								made to Liaison.
							</p>
							<p>
								Alternatively, you may choose the Pay In-Store Service option,
								where you make an Appointment/Order without using Liaison
								Payment Services and pay the Partner directly. The Partner may
								have the option to charge your payment method saved to the
								Liaison Account at checkout for Pay In-Store Services. This
								option is available based on the Partner's preferences and may
								not be offered by all Partners.
							</p>
							<p>
								Liaison utilizes a third-party payment processor (the "Payment
								Processor") to link the payment card you provide to the Liaison
								Platform. The processing of payments or credits related to your
								use of the Liaison Platform is subject to the privacy policies,
								terms and conditions, and other terms of the Payment Processor
								and your credit card issuer, in addition to these Terms of
								Service.
							</p>
							<p>
								While Liaison takes reasonable care to ensure the availability
								and functionality of the Liaison Payment Services, we cannot
								guarantee continuous, uninterrupted, or secure access to these
								services, nor can we guarantee that the facility is free from
								viruses or errors. Liaison is not responsible for any errors
								made by the Payment Processor. Occasionally, access to Payment
								Processing may be restricted for repairs, maintenance, or the
								introduction of new facilities or services. We will endeavor to
								provide reasonable notice of any scheduled interruptions and
								restore the facility as soon as possible.
							</p>
							<p>
								The Partner is responsible for any indirect taxes, such as sales
								tax, VAT, GST, or service tax, on the total value of an
								Appointment/Order, including any adjustments for additional
								goods or services sold or discounts applied. Apart from VAT or
								other applicable sales taxes included in the price shown on the
								Liaison Platform, Liaison does not charge taxes on Orders, as
								the Partner Services are provided by the Partner. If you order
								through the Liaison Platform, we will provide a tax invoice. If
								you order directly from a Partner, the Partner will provide a
								tax invoice upon request.
							</p>
							<p>
								All Products in an Order are subject to taxes, with the highest
								applicable Product tax applied for shipping, if relevant. If
								Products within an Order have different tax rates, the highest
								tax rate will apply to all Products in that Order.
							</p>
							<h3>Appointment changes and cancellations&nbsp;</h3>
							<p>
								If you need to reschedule your Appointment after receiving a
								Confirmation, you can do so through the Liaison Platform or by
								contacting the Partner directly. However, rescheduling may only
								be possible within a timeframe specified by the Partner in their
								Terms of Sale, which will be disclosed to you at the time of
								booking. Please review the Cancellation Policy before confirming
								your Appointment, as it may affect your ability to reschedule.
								Keep in mind that rescheduling is subject to the Partner's
								availability.
							</p>
							<p>
								Partners may require a deposit, known as Partner Credits, to
								confirm your Appointment. This deposit can be up to 100% of the
								Appointment's value and is governed by the Partner Contract,
								including any Deposit Policy. Before completing the Appointment,
								we recommend reviewing the Partner Contract to understand any
								deposit requirements. Please note that deposits may be
								non-refundable, and Liaison is not liable for any deposits made
								to a Partner.
							</p>
							<p>
								If you need to cancel your Appointment, you can do so through
								the Liaison Platform or by contacting the Partner directly.
								However, cancellation through the Liaison Platform is only
								possible if it falls outside the timeframe specified by the
								Partner in their Terms of Sale. The timeframe for cancellation
								will vary depending on the Partner and will be disclosed to you
								when you make your Appointment.
							</p>
							<p>
								Partners may have a Cancellation Policy in place, which will be
								presented to you at the time of booking. If a Cancellation
								Policy is in effect, Liaison may charge your card according to
								the Partner's terms, which could be up to the full amount of the
								Appointment. If you cancel beyond the specified timeframe in the
								Partner's Cancellation Policy, you may not be entitled to any
								refund unless agreed upon directly with the Partner.
							</p>
							<p>
								Additionally, Partners may have a No Show Policy. If you fail to
								attend your Appointment without notice, the Partner may choose
								to enforce their No Show Policy, resulting in a charge of up to
								the full amount of the Appointment to your card.
							</p>
							<p>
								Please note that no refund will be provided if a cancellation is
								attempted within the timeframe specified by the Partner's
								Cancellation Policy.
							</p>
							<h3>Product refunds and cancellations</h3>
							<p>
								When you purchase products from our Partners through the Liaison
								Platform, you are buying directly from the Partner, not from
								Liaison. Our Partners are responsible for all aspects of the
								sale, including marketing, advertising, delivery, and any
								post-sale support.
							</p>
							<p>
								If you encounter any issues with a product, such as
								dissatisfaction, defects, or delays, you should contact the
								Partner who sold the product directly. Below, we outline the
								cancellation and refund policies provided by Partners as a
								minimum standard.
							</p>
							<p>Product Delivery:</p>
							<ul>
								<li>
									Your order will be fulfilled within the delivery date
									specified in the Confirmation or, if not specified, within 30
									days from the Confirmation date, unless exceptional
									circumstances arise.
								</li>
								<li>
									Delivery will be made to the address you provide when placing
									your order. Please note that PO Box addresses are not accepted
									for delivery.
								</li>
								<li>
									Partners determine the countries and addresses to which they
									will ship products.
								</li>
								<li>
									When ordering products for delivery outside the Partner's
									country, customs or import duties may apply upon delivery. You
									are responsible for paying any such duties and taxes.
								</li>
								<li>
									Customs authorities may inspect and open packages, and
									products may be subject to additional charges upon arrival at
									the destination. Liaison cannot predict these charges, so it's
									advisable to check with your local customs office before
									placing an order.
								</li>
								<li>
									You must comply with all laws and regulations of the
									destination country for the ordered products. Liaison is not
									liable for any breaches of these laws.
								</li>
							</ul>
							<p>
								Please note that the terms and conditions for product delivery
								may vary depending on the Partner.
							</p>
							<h3>Faulty products</h3>
							<p>
								If any product you order arrives damaged or faulty, the Partner
								may offer options such as repair, exchange, or refund, in
								accordance with your legal rights. If you believe a product was
								delivered in a damaged or faulty condition, you must notify the
								Partner in writing, providing details such as your name,
								delivery address, and order reference. It's important to note
								that this process does not affect your legal rights.
							</p>
							<p>
								If you need assistance with a product order, please direct your
								inquiries to the relevant Partner who supplied the product. You
								can find the contact details for each Partner in the
								Confirmation or their Partner Profile within the Liaison
								Platform. They will be able to assist you further with any
								questions or concerns you may have about your product order.
							</p>
							<h3>Restrictions on access</h3>
							<p>
								Liaison retains the right to partially or fully restrict your
								access to the Liaison Services or Liaison Platform under certain
								circumstances, including but not limited to:
							</p>
							<ol>
								<li>
									A history of numerous canceled appointments, no-shows,
									refunds, chargebacks, or other negative transactions that
									impact the experience of our Partners.
								</li>
								<li>
									Failure to pass any credit or fraud prevention check conducted
									by the Liaison Payment Services.
								</li>
								<li>
									Reasonable suspicion of fraud or money laundering involving
									you or someone using your Liaison Account.
								</li>
								<li>
									Reasonable suspicion of compromised security regarding your
									Liaison Account.
								</li>
								<li>
									Inappropriate, abusive, or offensive behavior towards Liaison
									staff, employees of Partners, whether via phone, email,
									Liaison Platform communications, or in-person interactions at
									Partner premises, or violation of our Terms of Use.
								</li>
								<li>
									Breach of other terms outlined in these Terms of Service,
									including commitments made to us.
								</li>
								<li>
									Reasonable belief, at our sole discretion, that your actions
									are negatively impacting the quality of Liaison Services.
								</li>
							</ol>
							<p>
								Additionally, since Partner Services are sold by our Partners
								and not directly by Liaison, Partners may impose additional
								restrictions on who can purchase and book their services. These
								restrictions may include:
							</p>
							<ol>
								<li>Limiting access to their Partner Profile.</li>
								<li>
									Preventing you from booking appointments or ordering Partner
									Services they offer.
								</li>
								<li>
									Otherwise limiting your ability to engage with them on the
									Liaison Platform.
								</li>
							</ol>
							<p>
								These restrictions are determined solely by the Partners, and
								Liaison cannot override them to grant access to Partner
								Services.
							</p>
							<h3>Liability</h3>
							<p>
								Where Liaison has been negligent or breached a contractual
								obligation to you, we will be liable for any foreseeable loss or
								damage you suffer as a result. Loss or damage is considered
								foreseeable if it is an obvious consequence of our negligence or
								breach of contract, or if you and we would have reasonably
								anticipated it at the time you accepted these Terms of Service.
							</p>
							<p>
								However, we do not accept liability for certain types of loss,
								even if they result from breach of contract, negligence, or
								other legal grounds. These types of loss include:
							</p>
							<ol>
								<li>Loss of income or revenue</li>
								<li>Loss of business</li>
								<li>Loss of profits</li>
								<li>Loss of anticipated savings</li>
								<li>Waste of management or office time</li>
							</ol>

							<p>
								It's important to understand that we are not liable to you for
								the provision or non-provision of Partner Services and/or
								Products. The Partner with whom you have a contract is
								responsible for fulfilling all Partner Services and delivering
								Products under your agreement with them.
							</p>
							<h3>Indemnity</h3>
							<p>
								You agree to indemnify and hold Liaison (including its
								subsidiaries, agents, licensors, managers, affiliated companies,
								and their staff members, contractors, agents, officers, and
								directors) harmless from and against any and all claims,
								damages, obligations, losses, liabilities, costs, or debt,
								including attorney's fees and costs, arising out of or related
								to:
							</p>
							<ol>
								<li>
									Your use (or misuse) of the Liaison Services or Liaison
									Platform, including any data or content transmitted or
									received by you.
								</li>
								<li>
									Personal information or any other information or content
									submitted via your customer account, including misleading,
									false, or inaccurate information.
								</li>
								<li>
									Your breach or violation of any term of these Terms of Service
									or any applicable law, rule, or regulation.
								</li>
								<li>
									Your violation of any rights of any third party, including
									Partners.
								</li>
								<li>Negligent or willful misconduct on your part.</li>
								<li>
									Any other party's access and use of the Liaison Services with
									your unique username, password, or other appropriate security
									code.
								</li>
							</ol>
							<h3>General</h3>

							<p>
								Clients' use of the Liaison Platform is currently free of
								charge. However, Liaison reserves the right to introduce a fee
								for the use of the Liaison Platform in the future. If Liaison
								decides to implement such a fee, clients will be notified in
								advance and given the option to continue or discontinue using
								the Liaison services.
							</p>
							<p>
								You may not assign your rights under these Terms of Service
								without prior written approval from Liaison.
							</p>
							<p>
								Liaison may provide notices through general notices on the
								Liaison Platform, by email, or by post sent by regular
								mail.&nbsp;
							</p>
							<p>
								The Terms of Service, along with any referenced documents,
								constitute the entire agreement between you and Liaison,
								governing your use of the Liaison Services, and supersede any
								prior versions of these Terms of Service.
							</p>
							<p>
								Liaison's failure to exercise or enforce any right or provision
								of the Terms of Service does not constitute a waiver of such
								right or provision. If any provision of these Terms of Service
								is found to be invalid, unlawful, or unenforceable to any
								extent, the remaining provisions will remain in full force and
								effect.
							</p>
							<p>
								These Terms of Service will be governed by and construed in
								accordance with the laws of England. Both parties agree that the
								English courts will have non-exclusive jurisdiction over any
								claim or dispute arising from, or related to, the ordering
								and/or supply of Partner Services via the Liaison Platform.
							</p>
							<p>
								In these Terms of Service, defined words in the singular retain
								the same definition in the plural, and vice versa. Masculine
								words include the feminine, and vice versa.
							</p>
							<p>
								We reserve the right to update these Terms of Service
								periodically, and any changes will be posted on this page.
								Liaison may revise, modify, or replace any of these Terms of
								Service, or alter, suspend, or terminate the Liaison Services
								(including, but not limited to, the availability of any feature,
								database, or content) at any time.
							</p>
							<p>
								Your continued use of the Liaison Platform after the posting of
								changes signifies your acceptance and agreement to the revised
								Terms of Service. As long as you adhere to these Terms of
								Service, Liaison grants you a personal, non-exclusive,
								non-transferable, and limited privilege to access and utilize
								the Liaison Platform.
							</p>
							<p>
								Liaison reserves the right to impose restrictions on specific
								features and services, or limit your access to certain parts or
								the entirety of the Liaison Services without prior notice or
								liability. However, any modifications made will not affect any
								Bookings/Orders already placed.
							</p>

							<h2>
								<strong>Marketplace Payments</strong>
							</h2>
							<p>
								<span>
									On the Liaison platform, payments between Consumers and
									Service Professionals, known as "Marketplace Payments," may be
									carried out through Liaison's payment processing partner.
									However, Liaison is not involved as a party in these
									Marketplace Payments or any related Pro Services. Marketplace
									Payments are generally restricted to services only, with
									payments for tangible personal property being prohibited
									unless stated otherwise.
								</span>
							</p>
							<p>
								<span>
									By accepting these terms or by continuing as a Service
									Professional on the Platform, you authorize Liaison to act on
									your behalf as your agent. This authorization is limited to
									facilitating and receiving Marketplace Payments as described
									here. You recognize and agree that once a Marketplace Payment
									is executed through the Liaison Platform, the obligation of
									the paying User is considered fulfilled by the receiving User
									when Liaison receives the Marketplace Payment. This is as if
									the paying User had made the payment directly to the receiving
									User, subject to any rights you might have concerning disputes
									over Marketplace Payments.
								</span>
							</p>
							<p>
								<span>
									Liaison's role is not that of a direct provider or seller of
									professional services. Unless outlined in a separate contract
									where Liaison is an explicit party, the platform does not
									directly or indirectly provide or offer any professional
									services. When a Consumer books or pays for Pro Services or
									receives a quote related to Pro Services on the Platform, the
									Consumer is entering into a contract with the Service
									Professional who provides those services.
								</span>
							</p>
							<p>
								<span>
									Despite facilitating the booking or payment process, you must
									recognize and agree that Liaison (i) neither offers, sells,
									supplies, nor subcontracts any Pro Services, and (ii) holds no
									liability concerning any Pro Services. The only exception is
									what's expressly covered in the Liaison Guarantee, which
									applies solely in connection with Liaison's role as a
									marketplace, not as a provider of Pro Services.
								</span>
							</p>
							<p>
								<span>
									Regardless of Liaison's position as a payment facilitator,
									every Service Professional who gets paid through Marketplace
									Payments must acknowledge and agree to perform the Pro Service
									according to their agreement with the Consumer. They must also
									address any substantial deviations from the contract.
								</span>
							</p>
							<p>
								<span>
									For those operating as Service Professionals on Liaison and
									receiving Marketplace Payments from Consumers, adherence to
									the Stripe Connected Account Agreement is mandatory, and this
									includes compliance with the Stripe Services Agreement. Prior
									to accepting a Marketplace Payment or committing to perform
									services, Service Professionals must ensure their ability to
									fulfill the Stripe agreements. A crucial note is that a social
									security number or employer identification number will be
									necessary to receive these payments.
								</span>
							</p>
							<p>
								<span>
									By engaging as a Service Professional on Liaison, you signify
									your agreement to abide by the{" "}
								</span>
								<a href="https://stripe.com/us/connect-account/legal">
									<span>Stripe Connected Account Agreement</span>
								</a>
								<span> and </span>
								<a href="https://stripe.com/us/legal">
									<span>Stripe Services Agreement</span>
								</a>
								<span>
									, even if Stripe modifies these agreements over time. It is
									required that you furnish Liaison with precise and
									comprehensive information about yourself and your enterprise.
									You also permit Liaison to divulge this information, along
									with transaction details linked to the payment processing
									services supplied by Stripe. Furthermore, you consent to
									Liaison debiting your Stripe account if there are
									disagreements with Consumers.
								</span>
							</p>
							<p>
								<span>
									Liaison holds the authority to execute such debits and to
									defer final disbursements until after a dispute investigation.
									Liaison's ultimate decision on disputes will be at their
									exclusive discretion. As a Service Professional, you should
									recognize that any Marketplace Payments you may accumulate on
									the Platform are liable to these resolutions. Also, you concur
									that Liaison may annul payments deposited into a Service
									Professional's Stripe Connected Account if a customer
									repayment or guarantee disbursement is justified, particularly
									if linked to conduct or inactivity that violates these Terms.
								</span>
							</p>
							<p>
								<span>
									For Consumers partaking in Marketplace Payments through
									Stripe, your agreement is required to disburse all sums owed
									promptly with your chosen payment method. You are also
									authorizing Stripe to invoice your chosen payment method for
									owed amounts, be it for recurring or one-time fees. It is your
									responsibility to maintain the accuracy and current status of
									all payment information. Your agreement to our Stored Payment
									Terms and Conditions is implied when you record a payment
									method with us. It's vital not to distribute your payment
									card, bank account, or any other financial information with
									other Users.
								</span>
							</p>
							<p>
								<span>
									Though measures are taken to safeguard all payment methods and
									personal financial details, we explicitly renounce any
									responsibility to you, and you consent to absolve us from any
									harm you might experience due to the unintended leakage of
									your personal financial information.
								</span>
							</p>
							<p>
								<span>
									Through Liaison, you may have the option to conduct
									Marketplace Payments using various means such as credit,
									debit, or prepaid cards, linking to your bank account, or
									employing any other endorsed payment method. In our sole and
									absolute discretion, we retain the authority to revoke your
									privilege to execute payments using one or multiple authorized
									payment methods.
								</span>
							</p>
							<p>
								<span>
									Should you opt for your bank account as the mechanism for
									Marketplace Payment, you provide authorization to Stripe for
									the execution of Automated Clearing House (&ldquo;ACH&rdquo;)
									deductions from said account. Additionally, you permit any
									inquiries deemed essential by us to authenticate any disputes
									related to payments made to us or another User. These
									inquiries may encompass ordering a credit report, conducting
									other credit assessments, or corroborating the information
									supplied by you with third-party databases. You sanction
									Liaison or our service provider to initiate one or more ACH
									debit entries or form an equivalent bank draft for the defined
									amount(s), and the bank holding your account is authorized by
									you to make such deductions. This includes the deduction of
									payments as stipulated in amounts and frequency in your
									Account, with this authorization persisting until you provide
									a written cancellation. Changes to your account details or the
									termination of your authorization must be communicated to us
									at least five days before your forthcoming payment.
								</span>
							</p>
							<p>
								<span>
									Should the full payment not be processed simultaneously by us,
									partial debits from your bank account are hereby authorized by
									you, provided that they do not surpass the complete amount of
									your order. You consent to bear any ACH fees or penalties that
									either you or we may accrue in connection with the
									transactions you have approved. Based on your state of
									residence, these return fees will differ and may be added to
									your payment amount and deducted from your bank account if an
									ACH debit is resubmitted due to inadequate funds. We retain
									the right to initiate either a collection process or legal
									proceedings to recover any outstanding sums. You agree to
									cover all associated costs, including reasonable attorneys'
									fees. Any fraudulent, erroneous, or unauthorized transactions
									from your bank account are subject to federal law limitations
									on your liability. This is based on the promptness with which
									you report them to your financial institution, a deadline of
									no more than 60 days after the transaction in question appears
									on your bank account statement. Consult your bank to
									understand the procedures and regulations that govern
									unauthorized transactions and the limitations on your
									responsibilities.
								</span>
							</p>

							<h2>
								<strong>Subscriptions</strong>
							</h2>
							<p>
								Some sites offer the option to enroll in a monthly or yearly
								subscription for certain services.
							</p>
							<p>
								During the Subscriber's Agreement Term with Liaison, the
								Subscriber is granted access to Products and Services,
								including: (i) a back-end that operates in the cloud, where it
								performs functions such as storing, analyzing, managing,
								distributing, and processing data; and (ii) front-end clients
								such as mobile applications, web interfaces, plugins, and system
								connectors, facilitating the retrieval, presentation,
								distribution, and management of various aspects of the
								Subscriber's business. Liaison's solutions enable the Subscriber
								to manage all relevant facets of their online marketing campaign
								in a singular location (the Liaison Platform) by utilizing these
								Products and Services. Some functionalities or access within the
								platform might necessitate a distinct Subscription or adherence
								to supplementary terms and conditions.
							</p>
							<h3>
								<strong>Definitions</strong>
							</h3>
							<p>
								Below is an explanation of the capitalized terms as mentioned in
								the Agreement:
							</p>
							<ul>
								<li>
									<strong>"Claim"</strong>: This refers to a legal demand,
									action, or proceeding filed against a Party.
								</li>
								<li>
									<strong>"Confidential Information"</strong>: Information that
									is non-public, proprietary, and confidential to the disclosing
									Party's business, following specific criteria as described.
								</li>
								<li>
									<strong>"Party"</strong>: Either Liaison or Subscriber,
									collectively referred to as the Parties.
								</li>
								<li>
									<strong>"Personal Data"</strong>: Information relating to an
									identifiable individual.
								</li>
								<li>
									<strong>"Platform Subscription Term"</strong>: The duration of
									the Liaison Platform Subscription as detailed in the Sales
									Order.
								</li>
								<li>
									<strong>"Products and Services"</strong>: The specific
									products and services mentioned in the Sales Order.
								</li>
								<li>
									<strong>"Liaison"</strong>: Refers to Liaison Inc, a Delaware
									limited liability corporation.
								</li>
								<li>
									<strong>"Liaison Platform Cost"</strong>: The recurring
									monthly subscription cost for access to the Liaison Platform.
								</li>
								<li>
									<strong>"Services"</strong>: The Subscriber's offered services
									to end-users.
								</li>
								<li>
									<strong>"Subscriber"</strong>: The entity named in the active
									subscriptions of Liaison's Products and Services.
								</li>
								<li>
									<strong>"Subscriber Data"</strong>: All content and data
									belonging to the Subscriber used in or by the Products and
									Services.
								</li>
								<li>
									<strong>"Subscription"</strong>: The active subscriptions of
									Liaison's Products and Services that the Subscriber has
									engaged.
								</li>
								<li>
									<strong>"Subscription Term"</strong>: The cumulative duration
									of all Subscriptions for Products and Services.
								</li>
								<li>
									<strong>"Taxes"</strong>: Various governmental charges that
									may arise from the Agreement.
								</li>
								<li>
									<strong>"Term"</strong>: The existing Subscription term.
								</li>
								<li>
									<strong>"Third-Party Product(s)"</strong>: Products or
									services not developed by Liaison but may interact with the
									Products and Services or Subscriber Data.
								</li>
								<li>
									<strong>"User"</strong>: The Subscriber, an authorized
									employee of the Subscriber, or an authorized third-party of
									the Subscriber.
								</li>
							</ul>
							<h3>
								<strong>Subscriber Data</strong>
							</h3>
							<p>
								The Subscriber must ensure that their data (Subscriber Data)
								complies with all applicable laws, regulations, and does not
								infringe upon third-party intellectual property rights. The
								Subscriber is obligated to take reasonable measures to promptly
								identify and remove any Subscriber Data that violates these
								requirements. The Subscriber guarantees that their Data will not
								contain any Sensitive Personal Information and that all their
								activities regarding the collection, transfer, and use of any
								Personal Data processed through the Products and Services will
								adhere to relevant privacy laws, regulations, and
								self-regulatory guidelines. This compliance includes obtaining
								all necessary consents and making proper disclosures through the
								Subscriber's privacy policy to process any Personal Data with
								the Products and Services.
							</p>
							<h3>
								<strong>Subscriber Obligations</strong>
							</h3>
							<p>
								The Subscriber is responsible for (i) defending, at their own
								cost, and (ii) paying any damages awarded by a competent court
								(or agreed upon in a written settlement) related to third-party
								Claims that allege a breach by the Subscriber of applicable data
								protection laws and regulations. This responsibility includes
								failure to adhere to the Subscriber's own data privacy policy
								and the terms of the Agreement.
							</p>
							<h3>
								<strong>Payments</strong>
							</h3>
							<p>
								The Subscriber is obligated to pay Liaison the total amounts due
								according to the Agreement, with payments to be made in full on
								the specified due date(s). The Subscriber grants Liaison
								irrevocable permission to charge the provided credit card for
								all such amounts when they are due throughout the Term. Should
								the designated credit card account be canceled, replaced,
								renewed, lost, or stolen, the Subscriber agrees to notify
								Liaison in writing. All due amounts will be automatically
								charged in advance and are non-refundable. If the Subscriber
								fails to pay any Subscription Cost on any Liaison agreement,
								Liaison is not obligated to provide any Subscriptions.
							</p>
							<p>
								Should Liaison suspend any Subscriptions due to non-payment by
								the Subscriber, the Subscriber consents to owing all amounts
								that would have been due for the rest of the Term of the
								suspended Subscriptions, as though they had not been suspended.
								In the event that Liaison does not receive payment on time for
								any amount owed under the Agreement, the Subscriber agrees to
								pay all amounts pursuant to the Agreement immediately upon
								request. Furthermore, the Subscriber will cover Liaison for any
								charges and fees incurred while collecting delinquent
								Subscription Cost(s). If there are any past due balances, the
								Subscriber may be charged up to the maximum legal interest rate,
								where such interest is deemed liquidated damages and not
								considered a penalty.
							</p>
							<h3>
								<strong>Subscription Levels</strong>
							</h3>
							<p>
								You have the option to add, change, remove, elevate, or reduce
								(Subscription Modification) specific Subscriptions through the
								Platform. When a Subscription Modification occurs, you grant us
								permission to charge the newly prorated amount for the existing
								Term and to invoice the total revised Subscription Cost for all
								merged Subscriptions going forward to the corresponding payment
								method connected with your account. It is essential to
								understand that reducing your plan might result in the loss of
								data, information, features, or other functionalities tied to
								your account, and it may also lead to a re-evaluation of your
								projected future growth metrics. All risks associated with
								downgrading any service are yours, and you absolve Liaison from
								any responsibility or outcomes linked to it. In certain
								instances, Liaison may introduce, alter, phase out, decrease, or
								eliminate particular features and functionalities, but such
								modifications will not substantially negatively affect the
								Subscriber's utilization of the Products and Services. If such
								changes occur, the Subscriber's only recourse is to notify the
								termination of the concerned Subscription within thirty (30)
								days from the notice of alteration.
							</p>

							<h3>
								<strong>Supplemental Subscriptions</strong>
							</h3>
							<p>
								Occasionally, Liaison might introduce features or services that
								are governed by distinct terms and possibly additional charges.
								You may not utilize these extra features and services unless you
								accept the relevant terms. Liaison might also grant access to
								subscriptions, features, or services identified as beta or
								pre-release. You recognize that these services are still under
								development and may contain bugs or errors, be incomplete,
								undergo significant alterations before full commercial release,
								or may never be commercially launched. Notwithstanding any other
								clause of this Agreement, any utilization or reliance on beta or
								pre-release subscriptions, features, or services is at the
								Subscriber's risk and provided on an "as-is" basis without any
								warranty, and Liaison's indemnity Section herein does not apply
								to such beta or pre-release features or services.
							</p>
							<h3>
								<strong>Results</strong>
							</h3>
							<p>
								The Subscriber recognizes that various factors influence search
								outcomes, search engine positions, and advertising outcomes.
								Liaison makes no commitments or guarantees regarding the
								position, placement, or rank of the Website or advertisement
								within any search engine or advertising network channel. No
								representations, warranties, or guarantees concerning the
								Subscriptions' results or performance, such as the Internet
								traffic's quality or quantity, or the business or revenue that
								the Subscriptions may generate, have been made by Liaison to the
								Subscriber. Liaison may utilize collective data from all
								Subscribers to generate audience insights, which might be
								applied for general advertising and possible consumer profiling.
								Additionally, the Subscriber explicitly affirms that they are
								not depending on anything (whether conveyed in writing or
								verbally) beyond the terms stipulated in this written agreement.
							</p>
							<h3>
								<strong>Ownership</strong>
							</h3>
							<p>
								Exclusively, Liaison owns the Technology and any enhancements to
								it, regardless of whether they are developed under this
								Agreement ("Liaison Proprietary Data"). The Subscriber will
								neither acquire an ownership stake due to this Agreement nor
								attempt to obtain any Liaison Proprietary Data. On the other
								hand, Subscriber Data remains the sole property of the
								Subscriber. It is clearly understood that the Subscriber will
								never possess any rights, title, viewing privileges, or
								ownership of any aspect of Machine Learning Advertising and/or
								SAM.
							</p>
							<p>
								Neither party will, during the Term and thereafter, disclose,
								utilize, or furnish the other's confidential information and/or
								property to a third party, except as specifically outlined in
								this Agreement or as required for the Parties to fulfill their
								duties or assert or uphold their rights under this Agreement.
								Additionally, the Subscriber will never gain any rights, title,
								or ownership over any portion of the Products and Services.
							</p>
							<h3>
								<strong>Parental Controls</strong>
							</h3>
							<p>
								<span>
									We have established a privacy policy covering the collection,
									use, and disclosure of user information, which can be found{" "}
								</span>
								<a href="/privacy-policy">
									<span>here</span>
								</a>
								<span>.</span>
							</p>
							<h2>
								<strong>Notice for California Residents</strong>
							</h2>
							<p>
								<span>
									Under California Civil Code Section 1789.3, California users
									are entitled to the following consumer rights notice: If you
									have a question or complaint regarding the site, please{" "}
								</span>
								<a href={LINK_HELP_CONTACT}>
									<span>contact us</span>
								</a>
								<span>
									. California residents may reach the Complaint Assistance Unit
									of the Division of Consumer Services by mail at 1625 North
									Market Blvd., Suite N 112, Sacramento, California 95834, or by
									telephone at (916) 445-1254 or (800) 952-5210. Please be sure
									to identify the specific website, software, or service about
									which you have a question or complaint and how we can contact
									you.
								</span>
							</p>
							<h2>
								<strong>
									Dispute Resolution; Arbitration and Class Action Waiver
								</strong>
							</h2>
							<p>
								<span>
									We believe we will be able to resolve most disputes or issues
									you may have using our sites and services. In the unlikely
									event we are not able to resolve a dispute or issue, we prefer
									to specify now what each of us should expect in order to avoid
									any confusion later. Accordingly, you agree to the following
									resolution process.
								</span>
							</p>
							<p>
								<span>
									Since we always prefer to find ways to satisfy you as quickly
									and efficiently as possible, before initiating any arbitration
									proceeding, you agree to first discuss the matter informally
									with us for at least 30 days. To do that, please send your
									full name and contact information, your concern and your
									proposed solution by{" "}
								</span>
								<a href={LINK_HELP_CONTACT}>
									<span>email</span>
								</a>
								<span>
									{" "}
									and mail to us at: Liaison, Inc 1301 San Bernard St., Austin,
									TX 78702, U.S.A, Attn: Legal Department.
								</span>
							</p>
							<p>
								<span>
									If we are unable to mutually agree upon a resolution after the
									30-day period, you agree that any claim you may have against
									us regarding these TOU or our sites and services will be
									resolved through binding arbitration administered by JAMS and
									governed by the then current JAMS Streamlined Arbitration
									Rules and Procedures. It is important to us that we address
									any issues you might have promptly. To help us do that, you
									agree to begin any arbitration within one year after your
									claim arose; otherwise, your claim is waived.
								</span>
							</p>
							<p>
								<span>
									We prefer to resolve our issues with you directly and,
									accordingly, you agree to arbitrate with us only in your
									individual capacity, not as a representative or member of a
									class. As such, your claims may not be joined with any other
									claims and there will be no authority for any dispute to be
									arbitrated on a class-action basis or brought by a purported
									class representative.
								</span>
							</p>
							<p>
								<span>
									You agree that arbitration will be exclusively held in Harris
									County, Texas and that each party will be responsible for its
									own costs, including paying any JAMS filing, administrative
									and arbitrator fees in accordance with JAMS rules. In order to
									select an arbitrator, each party agrees to provide a list of
									two available arbitrators that have experience with the
									subject matter. Each party may strike one of the names on the
									other party's list. The parties will select an arbitrator out
									of the remaining two arbitrator names. If the parties cannot
									mutually agree on one arbitrator, JAMS will choose the
									arbitrator randomly from the two remaining arbitrators. It is
									important that you understand that the arbitrator's decision
									will be binding and may be entered as a judgment in any court
									of competent jurisdiction. If you're not sure what all of this
									means, of course please feel free to ask an attorney.
								</span>
							</p>
							<p>
								<span>
									Both parties recognize that without this obligatory
									arbitration clause, they would possess the right to take legal
									action in court and to request a jury trial. They also
									comprehend that there might be cases where the expenses
									related to arbitration could surpass those of pursuing
									litigation, and that the opportunity to obtain discovery might
									be more restricted in arbitration compared to a court
									proceeding.
								</span>
							</p>
							<p>
								<span>
									Class Action Waiver: Both parties agree that the arbitration
									will proceed solely on an individual basis and not in any
									class or representative action. The right to initiate or
									participate in a class action or any other representative
									action is expressly waived by the parties. YOU AND LIAISON
									CONCUR THAT CLAIMS CAN ONLY BE BROUGHT AGAINST EACH OTHER IN
									AN INDIVIDUAL CAPACITY, NOT AS A PLAINTIFF OR MEMBER IN ANY
									ALLEGED CLASS OR REPRESENTATIVE LEGAL PROCEEDING. Should a
									court or arbitrator find the class action waiver in this
									paragraph to be void or unenforceable for any reason, or if it
									is determined that arbitration can proceed on a class basis,
									then the entire arbitration agreement outlined above will be
									considered null and void, and the parties will be regarded as
									having not agreed to arbitrate disputes.
								</span>
							</p>
							<p>
								<span>
									Exception: Claims Concerning Intellectual Property and Small
									Claims Court Cases: Despite the mutual agreement of the
									parties to settle all disputes via arbitration, either party
									has the right to bring enforcement actions, validity
									assessments, or claims stemming from theft, piracy, or
									unauthorized exploitation of intellectual property in state or
									federal court, or in the U.S. Patent and Trademark Office to
									safeguard their or our intellectual property rights
									("intellectual property rights'' here refer to patents,
									copyrights, moral rights, trademarks, trade dress, and trade
									secrets, but not privacy or publicity rights). For disputes or
									claims within the scope of its jurisdiction, either party may
									also pursue remedies in a small claims court.
								</span>
							</p>
							<p>
								<span>
									Right to Opt Out Within 30 Days: The right to opt out and not
									be subject to the arbitration and class action waiver
									stipulations mentioned above is yours. By{" "}
								</span>
								<a href={LINK_HELP_CONTACT}>
									<span>sending a written notice</span>
								</a>
								<span>
									{" "}
									of your decision to opt out (from the email address associated
									with your Liaison account) with the subject line "ARBITRATION
									AND CLASS ACTION WAIVER OPT-OUT," you can exercise this right.
									The notice has to be dispatched within thirty (30) days of
									either the Effective Date of these Terms or your initial use
									of the Platform; failing to do so means you will be obliged to
									settle disputes following the conditions of those paragraphs.
									If you choose to opt out of these arbitration terms, Liaison
									will also not be bound by them.
								</span>
							</p>
							<p>
								<span>
									Survival: The provisions within this Arbitration and Class
									Action Waiver section shall continue to be effective even
									after the termination of your Account or the Platform.
								</span>
							</p>
							<p>
								<strong>Governing Law</strong>
							</p>
							<p>
								<span>
									All aspects of the relationship between you and Liaison, as
									well as the Terms, will be governed by the laws of Texas,
									without considering its conflict of law principles. Any claims
									or disputes against Liaison that are not destined for
									arbitration must be addressed in a court situated in Travis
									County, Texas, or a United States District Court in the
									Western District of Texas, based in Austin, Texas, unless the
									parties agree otherwise. You consent to the personal
									jurisdiction of these courts in Travis County or the Western
									District of Texas for the purpose of litigating any such
									claims or disputes not going to arbitration. You willingly
									renounce any jurisdictional and venue defenses that might
									otherwise be available to you.
								</span>
							</p>
							<h2>
								<strong>Phone Calls</strong>
							</h2>
							<p>
								<span>
									By submitting your information you authorize and agree the
									operator of this website and its affiliates and partners may
									use any automated or non-automated technology to call you for
									any reason, including the use of ringless voicemail. Ringless
									voicemail may be employed to deliver messages directly to your
									voicemail service without ringing your telephone, for purposes
									including but not limited to marketing, promotions, updates,
									or any other informational content.
								</span>
							</p>
							<p>
								{" "}
								Calls will be between the hours of 9:00am to 8:00pm in your
								local timezone (based off your area code or zip code on file).
								Calls may be for sales, support and account maintenance,
								surveys, or any other reason. We may call to confirm your
								request along with SMS text messages or ringless voicemail
								services from up to five companies that can help you with your
								request to the land-line or mobile phone number you provided.
							</p>
							<p>
								<span>
									We, our affiliates, or our service providers call and send
									text messages to: (1) provide you with information you
									requested from Liaison; (2) inform you of improvements,
									features, or Liaison services that may be of interest to you;
									(3) facilitate the matching of Consumers with Service
									Professionals, (4) respond to your inquiries regarding your
									account or use of Liaison, (5) send you offers promoting any
									products or services, and (6) contact you about any of
									Liaison's or our affiliates other products and services.
								</span>
							</p>
							<p>
								<span>
									You understand that some of these calls or messages, including
									ringless voicemails, may originate from automated systems or
									artificial intelligence (AI). While we strive for accuracy,
									information provided by AI may sometimes be inaccurate. By
									accepting these terms, you agree not to hold us, our
									affiliates, or our partners liable for any inaccuracies or
									misrepresentations made by such automated systems or AI.
									Furthermore, you acknowledge that these companies may use
									automated phone technology, including robotic agents and
									ringless voicemail systems, to communicate with you. Please
									note that your consent is not a prerequisite for purchasing
									products or services.
								</span>
							</p>
							<p>
								<span>
									We reserve the right to modify these Phone Terms, or any part
									thereof, or add or remove terms at any time, and such
									modifications, additions or deletions will be effective
									immediately upon posting.
								</span>
							</p>
							{SITE_NAME === "homeguide" && (
								<>
									<h2>
										<strong>Partners cont.</strong>
									</h2>
									<p>
										<span>
											By submitting your information are subsequently electing
											to send your lead information immediatly to and use{" "}
										</span>
										<a href="https://www.networx.com/terms-use">
											<span>Networx's</span>
										</a>
										<span>, HomeAdvisor&rsquo;s, and </span>
										<a href="https://legal.angi.com/#privacy-policy">
											<span>Angi's</span>
										</a>
										<span>
											{" "}
											service and you are agreeing to HomeAdvisor&rsquo;s,
											Angi's, and CraftJack's{" "}
										</span>
										<a href="https://legal.angi.com/#contract-bjq4r3d6f">
											<span>&ldquo;Terms and Conditions&rdquo;</span>
										</a>
										<span> and </span>
										<a href="https://legal.angi.com/#privacy-policy">
											<span>&ldquo;Privacy Policy&rdquo;</span>
										</a>
										<span>
											, and are agreeing to being contacted by HomeAdvisor,
											Angi, or{" "}
										</span>
										<a href="https://legal.craftjack.com/#craftjack-consumer-terms-of-use">
											<span>CraftJack's</span>
										</a>
										<span>
											{" "}
											and other service professionals at the email address and
											phone number provided.
										</span>
									</p>
								</>
							)}

							<h2>
								<strong>SMS Terms and Conditions</strong>
							</h2>
							<p>
								<span>
									User's Acknowledgment and Acceptance of Terms: ("Liaison,"
									"we," "us," or "our") and its affiliates provides these SMS
									Terms and Conditions (the "SMS Terms"), which govern the
									provision and delivery of text messages by us or our text
									message service providers to you and phone calls by us or our
									automated systems. Liaison provides this service to Service
									Professionals and Consumers.
								</span>
							</p>
							<p>
								<span>
									If you are experiencing issues with the text messaging program
									you can reply with the keyword HELP for more assistance, STOP
									to stop all messages permanently, START to restart your SMS
									subscription, or you can get help directly by{" "}
								</span>
								<a href={LINK_HELP_CONTACT}>
									<span>contacting us</span>
								</a>
								<span>
									. If you have any questions regarding privacy, please read our
									privacy policy.
								</span>
							</p>
							<p>
								<span>
									We, our affiliates, or our service providers send text
									messages to: (1) provide you with information you requested
									from Liaison; (2) inform you of improvements, features, or
									Liaison services that may be of interest to you; (3)
									facilitate the matching of Consumers with Service
									Professionals, (4) respond to your inquiries regarding your
									account or use of Liaison, (5) send you offers promoting any
									products or services, and (6) contact you about any of
									Liaison's or our affiliates other products and services.
								</span>
							</p>
							<p>
								<span>
									By agreeing to receive text messages, you also consent to the
									use of an electronic record to document your agreement. You
									may withdraw your consent to the use of the electronic record
									by{" "}
								</span>
								<a href={LINK_HELP_CONTACT}>
									<span>emailing us</span>
								</a>
								<span>
									{" "}
									with "Revoke Electronic Consent" in the subject line.
								</span>
							</p>
							<p>
								<span>
									To view and retain a copy of this disclosure or any
									information regarding your enrollment in this program, you
									will need (i) a device (such as a computer or mobile phone)
									with a web browser and Internet access and (ii) either a
									printer or storage space on such device. For a free paper
									copy, or to update our records of your contact information,
									email support with contact information and the address for
									delivery.
								</span>
							</p>
							<p>
								<span>
									You may sign up to receive text messages through our website.
									By signing up to receive text messages, you agree to these SMS
									Terms, our Terms of Use, and our Privacy Policy.
								</span>
							</p>
							<p>
								<span>
									By signing up to receive text messages, you agree that Liaison
									or its agents and affiliates may use any automated or
									non-automated technology to send you informational and/or
									promotional text messages. The types of text messages you will
									receive depend on the SMS campaign(s) you opted into. You
									understand that you are not required to receive text messages
									as a condition of purchasing property, goods, or services from
									Liaison.
								</span>
							</p>
							<p>
								<span>
									We do not charge you for its text message program. But message
									and data rates may apply, so depending on your plan with your
									wireless or other applicable provider, you may be charged by
									your carrier or other applicable provider.
								</span>
							</p>

							<p>
								<span>
									Frequency of Text Messages: We may send you an initial message
									confirming that we have received your opt-in. After that, you
									will receive recurring text messages, and the specific amount
									may vary depending on how you use our services and whether you
									take steps to generate additional text messages from us (such
									as replying HELP to one of our text messages).
								</span>
							</p>
							<p>
								<span>
									Eligibility: By signing up to receive text messages, you
									represent that you are 18 years of age or older and understand
									the obligations and agree to the terms set forth in these SMS
									Terms and the Terms of Use, which both form binding agreements
									between you and us. You further represent that you are the
									subscriber of the cellular service at the mobile number
									provided or that you are authorized by the subscriber to
									sign-up for texts.
								</span>
							</p>
							<p>
								<span>
									Participating Carriers: Content is not available on all
									carriers and carrier participation could change. As of
									September 24, 2015, our text messages can be sent through the
									following carriers: AT&amp;T, T-Mobile USA, Verizon Wireless,
									Sprint, Advantage Cellular (DTC Wireless), Aio Wireless,
									Alaska Communications Systems (ACS), Appalachian Wireless
									(EKN), Bluegrass Cellular, Boost Mobile, Carolina West
									Wireless, CellCom, Cellular One of East Central IL (ECIT),
									Cellular One of Northeast Arizona, Cellular One of Northeast
									Pennsylvania, Chariton Valley Cellular, Cricket, Coral
									Wireless (Mobi PCS), Cross, C-Spire (CellSouth), Duet IP
									(Maximum Communications New Core Wireless), Element Mobile
									(Flat Wireless), Epic Touch (Elkhart Telephone), GCI, Golden
									State, Google Voice, Hawkeye (Chat Mobility), Hawkeye (NW
									Missouri), Illinois Valley Cellular, Inland Cellular,
									iWireless (Iowa Wireless), Keystone Wireless (Immix
									Wireless/PC Man), Metro PCS, Mosaic (Consolidated or CTC
									Telecom), MTA Communications, MTPCS (Cellular One Nation),
									Nex-Tech Wireless, NTelos, Panhandle Communications, Peoples
									Wireless, Pine Cellular, Pioneer, Plateau (Texas RSA 3 Ltd),
									RINA, Sagebrush Cellular (Nemont), SI Wireless/Mobile Nation,
									Simmetry (TMP Corporation), SouthernLinc, SRT Wireless, Thumb
									Cellular, Union Wireless, United Wireless, U.S. Cellular,
									Viaero Wireless, Virgin Mobile, and West Central (WCC or 5
									Star Wireless). The content is not compatible with all cell
									phone models. Liaison will not be liable for any delays in the
									receipt of any SMS messages or changes to the participating
									carriers as delivery is subject to effective transmission from
									your carrier with active participation at that time.
								</span>
							</p>
							<p>
								<span>
									Opting Out of Text Messages: If you no longer want to receive
									text messages, you may text STOP at any time. After doing so,
									we will send you confirmation of your opt-out via text
									message. If you have revoked consent and want to re-enroll in
									our text message program, you can re-enroll by contacting
									support.
								</span>
							</p>
							<p>
								<span>
									Modifications to these SMS Terms: We reserve the right to
									modify these SMS Terms, or any part thereof, or add or remove
									terms at any time, and such modifications, additions or
									deletions will be effective immediately upon posting. Your
									continued enrollment in our text messaging program shall be
									deemed to constitute acceptance by you of such modifications,
									additions or deletions.
								</span>
							</p>
							<h2>
								<strong>General and Miscellaneous</strong>
							</h2>
							<p>
								<span>
									Force Majeure: Excluding the obligations related to payment,
									neither you nor Liaison will be held accountable to the other
									for any delay or failure in performing under the TOU, if the
									cause is beyond either party's control and without fault or
									negligence. Such causes might encompass fires, floods,
									earthquakes, strikes, lack of essential utilities, blackouts,
									epidemics, acts of war (declared or undeclared), regulatory
									agency actions, or other catastrophes.
								</span>
							</p>
							<p>
								<span>
									No Third-Party Beneficiaries: Except as explicitly stated
									within these TOU, you concur that there will be no
									beneficiaries of these TOU who are not a party to them.
								</span>
							</p>
							<p>
								<span>
									Contacting You and E-SIGN Consent: Liaison may send notices to
									you via email, standard mail, or by posting on the Platform.
									With your agreement, Liaison, Consumers, Service
									Professionals, or others may contact you via phone or text
									messages. By consenting to receive phone calls or text
									messages, you also agree to an electronic record documenting
									your consent. You can revoke this consent by{" "}
								</span>
								<a href={LINK_HELP_CONTACT}>
									<span>emailing</span>
								</a>
								<span> "Revoke Electronic Consent.</span>
							</p>
							<p>
								<span>
									Entire Agreement: The full agreement between you and Liaison
									regarding the Platform or Pro Services obtained through it
									includes these TOU, the Privacy Policy, and any other legal
									notices or additional policies published by Liaison on the
									Platform. The TOU will remain in full effect even if a
									competent jurisdiction deems a provision invalid, excluding
									the invalidated provision.
								</span>
							</p>
							<p>
								<span>
									Waiver: Failing to assert any right or provision under these
									TOU will not constitute a waiver of that or any other
									provision. No waiver of any term will be considered a
									continuing waiver of that term or any other.
								</span>
							</p>
							<p>
								<span>
									Statute of Limitations: Any claims related to the Platform or
									Pro Services must begin within one year after the cause of
									action arises, notwithstanding any legal exceptions. Any claim
									not brought within this timeframe is permanently barred. This
									limitation does not apply to New Jersey residents.
								</span>
							</p>
							<p>
								<span>
									Section Headings: The headings in these TOU are for
									convenience and do not have legal or contractual significance.
								</span>
							</p>

							<h3>
								<strong>E-sign consent</strong>
							</h3>

							<p>
								Liaison, Inc., along with its affiliates and third-party service
								providers, may need to send you certain communications, notices,
								agreements, billing statements, or disclosures
								("Communications") concerning our Services. By agreeing to this
								E-sign Consent, you confirm your ability to receive these
								Communications electronically from Liaison, rather than in paper
								format, and you also consent to the use of electronic signatures
								in our interactions with you ("Consent"). If you decide not to
								accept this Consent or if you withdraw your consent later, you
								might be unable to use the Services.
							</p>
							<p>
								<strong>
									Electronic Delivery of Communications and Use of Electronic
									Signatures
								</strong>{" "}
								With this Consent, Liaison is authorized to deliver all
								Communications electronically, whether by email, text message,
								or through making them available on Liaison websites or
								applications. These Communications may include, but are not
								limited to, required agreements and policies for using the
								Services (such as this Consent, the Liaison Privacy Notice, and
								various Liaison agreements), payment authorizations, transaction
								receipts or confirmations, account statements and histories, as
								well as federal and state tax statements and documents. We may
								also utilize electronic signatures and request them from you as
								needed.
							</p>
							<p>
								<strong>
									Withdrawal of Consent to Electronic Communications
								</strong>{" "}
								You have the right to withdraw your consent to receive
								electronic Communications at any time. This can be done by
								sending a written notice to the designated Liaison address.
								Please be aware that withdrawing your consent may lead to the
								termination of your access to the Services. The withdrawal of
								your consent becomes effective after a reasonable period needed
								to process your request. Liaison will confirm the withdrawal and
								the date it takes effect either electronically or in paper
								format.
							</p>

							<h3>
								<strong>Tracking Communications</strong>
							</h3>
							<p>
								<span>
									Liaison may monitor communications between Consumers and
									Service Professionals that take place outside of the Platform,
									such as via email, phone call, SMS text message, third-party
									websites, or other means, in order to ensure the proper
									charging of Fees and adherence to these TOU. This tracking
									might include obscuring or replacing Service Professional
									contact information on their profile with alternative contact
									details that forward to the Service Professional, or other
									measures designed to track such communications. Except as
									specifically stated here, Liaison will not review or record
									the content of communications that do not interact with the
									Liaison Platform without first obtaining your consent.
								</span>
							</p>
							<p>
								<span>
									For the purpose of fraud prevention, proper charging of Fees,
									enforcing these TOU, and for quality and training, text
									messages between a Consumer and Service Professional using the
									phone numbers available on the Platform may be tracked by
									Liaison using a third-party service provider. As part of this
									process, both Liaison and the service provider will receive
									and store real-time data concerning your text messages, such
									as the content of the text message, the phone number, and the
									date and time when the message was sent.
								</span>
							</p>
							<h3>
								<strong>Sponsored Information</strong>
							</h3>
							<p>
								<span>
									Liaison has the right to display public advertisements,
									sponsored content, and other types of paid information. The
									way in which this advertising is presented can change without
									any specific notification to you. Service Professionals may
									pay Liaison to be highlighted in search results, leading them
									to rank higher. Any Service Professionals who have taken
									advantage of this will be clearly marked in the applicable
									search results. To qualify for an enhancement in search
									rankings, Service Professionals must meet certain quality
									standards that Liaison may enforce. These standards are
									subject to alteration at any time without prior notice.
								</span>
							</p>
							<h3>
								<strong>Rules for Sweepstakes, Contests and Promotions</strong>
							</h3>
							<p>
								<span>
									In addition to the terms and conditions of these TOU, any
									sweepstakes, contests, raffles or similar promotions
									(collectively, "Promotions") made available through our sites
									and services may be governed by specific rules. By
									participating in any such Promotion, you will become subject
									to those rules. To the extent that the terms and conditions of
									such rules conflict with these TOU, the terms and conditions
									of such rules will control.
								</span>
							</p>
							<p>
								<span>
									Liaison may extend various offers to you, referred to as
									"Promotions," which can include discounts, free usage of the
									Platform for a certain time, credits towards payments for Pro
									Services, referral incentives, and more. These Promotions are
									provided at Liaison's sole discretion and can be withdrawn at
									any time for any reason. If Liaison determines that you have
									attempted to manipulate, commit fraud, or otherwise violate
									the terms of a Promotion, your offer may be revoked. This
									includes actions such as providing false information or using
									multiple User accounts.
								</span>
							</p>
							<p>
								<span>
									To qualify for the benefits detailed in a Promotion, you must
									(a) have received a direct offer from Liaison for that
									specific Promotion, (b) meet all the requirements outlined in
									that communication, and (c) have an account in good standing
									with Liaison. Liaison can set conditions for receiving a
									Promotion benefit as deemed fit, including limiting
									eligibility to specific Users, categories, or dates. To
									qualify for a Promotion's benefits, you may be required to
									perform a specific action, such as signing up for a service,
									or making payment for particular services. Unless otherwise
									stated, Promotions are for one-time use only, and multiple
									Promotions cannot be combined for a single project.
								</span>
							</p>
							<p>
								<span>
									Details of the benefits, acceptance requirements, and any
									other conditions to receive the benefits of a Promotion will
									be disclosed to you. After the end of a Promotion, you will no
									longer be eligible to receive the benefits, even if you have
									met the requirements. Liaison reserves the right to revoke a
									benefit if it is believed that you have not fulfilled the
									Promotion's requirements, including maintaining an Account in
									good standing.
								</span>
							</p>
							<h3>
								<strong>Copyright, Trademark and Patent Notices</strong>
							</h3>
							<p>
								<span>
									Except as otherwise expressly provided, all contents of our
									sites and services are copyrighted. All rights reserved. Our
									registered trademarks are protected by United States and
									international laws. In addition, graphics, logos, page
									headers, button icons, scripts, and service names included in
									or made available through our sites and services are our
									trademarks (collectively, "our marks"). These TOU do not
									authorize you to use our marks or any similar or related marks
									for any use pertaining to classified advertising, Internet
									advertising, social networks, online forums, online
									communication services or any similar or related use, or any
									other use that is likely to cause confusion on the part of, to
									cause mistake by or to deceive the public as to any
									affiliation, connection, association, origin, sponsorship,
									approval or endorsement by or with us. One or more patents
									owned by us apply to our sites and services and to the
									features and services accessible via our sites and services.
								</span>
							</p>
							<h3>
								<strong>Reservation of Rights in our sites and services</strong>
							</h3>
							<p>
								<span>
									Subject to the limited rights expressly granted hereunder, we
									reserve all rights, title and interest in and to our sites and
									services, including all related intellectual property rights.
									No rights are granted to you hereunder other than as expressly
									set forth herein.
								</span>
							</p>
							<h3>
								<strong>Entire Agreement</strong>
							</h3>
							<p>
								<span>
									These TOU (along with any documents linked to in these TOU)
									constitute the entire agreement between you and us and
									supersede any prior written or oral agreement. Other than our
									representatives (who are expressly included as named
									third-party beneficiaries of these TOU), there are no
									third-party beneficiaries to these TOU. If any provision of
									these TOU is found by a court of competent jurisdiction to be
									unenforceable, all other provisions of these TOU will remain
									in full force and effect.
								</span>
							</p>
							<h3>
								<strong>Governing Law; Forum</strong>
							</h3>
							<p>
								<span>
									Any and all claims, causes of action or disputes (regardless
									of theory) between you and us arising out of or related to
									these TOU, our sites and services or content accessed through
									our sites and services will be governed by the laws of the
									State of California, without regard to conflict or choice of
									law principles.
								</span>
							</p>
							<p>
								<span>
									You agree that any claims, causes of action or disputes not
									subject to Section Dispute Resolution; Arbitration) will be
									brought exclusively in courts located within the county of
									Harris, Texas, and you agree to submit to the personal and
									exclusive jurisdiction of such courts, for any actions. You
									further agree that, regardless of any statute or law to the
									contrary, you must file any such claim or cause of action
									within one (1) year after such claim or cause of action arose
									or be forever barred.
								</span>
							</p>
							<p>
								<span>
									All claims not subject to Section (Dispute Resolution;
									Arbitration) that you bring against us must be resolved in
									accordance with Section 19(e). All claims filed or brought
									contrary to this section will be considered improperly filed.
									Should you file a claim contrary to this section, we may
									recover attorneys. fees and costs up to U.S. $2,500 provided
									that we have notified you in writing of the improperly filed
									claim and you have failed to properly withdraw the claim.
								</span>
							</p>
							<p>
								<strong>Electronic Communications</strong>
							</p>
							<p>
								<span>
									When you use our sites and services, or send emails to us, you
									are communicating with us electronically. You consent to
									receive communications from us electronically. We will
									communicate with you by email or by posting notices on our
									sites and services. You agree that all agreements, notices,
									disclosures and other communications that we provide to you
									electronically satisfy any legal requirement that such
									communications be in writing.
								</span>
							</p>
							<h3>
								<strong>Electronic Contracting</strong>
							</h3>
							<p>
								<span>
									Your use of our sites and services includes the ability to
									enter into agreements and/or to make transactions
									electronically. YOU ACKNOWLEDGE THAT YOUR ELECTRONIC
									SUBMISSIONS CONSTITUTE YOUR AGREEMENT AND INTENT TO BE BOUND
									BY AND TO PAY FOR SUCH AGREEMENTS AND TRANSACTIONS. YOUR
									AGREEMENT AND INTENT TO BE BOUND BY ELECTRONIC SUBMISSIONS
									APPLIES TO ALL RECORDS RELATING TO ALL TRANSACTIONS YOU ENTER
									INTO ON THIS SERVICE, INCLUDING NOTICES OF CANCELLATION,
									POLICIES, CONTRACTS, AND APPLICATIONS. In order to access and
									retain your electronic records, you may be required to have
									certain hardware and software, which are your sole
									responsibility.
								</span>
							</p>
							<h3>
								<strong>Termination; No Assignment</strong>
							</h3>
							<p>
								<span>
									You may terminate your account and/or stop using our sites and
									services at any time. We may, in our sole discretion,
									terminate or suspend your access to all or part of our sites
									and services for any reason, including, without limitation,
									violation of these TOU and/or if we have a reasonable ground
									to suspect that you have violated these TOU.
								</span>
							</p>
							<p>
								<span>
									These TOU and the rights granted and obligations undertaken,
									may not be transferred, assigned or delegated by you. Any
									purported attempt will be ineffective. We retain the right to
									transfer, assign or delegate these TOU.
								</span>
							</p>
							<h3>
								<strong>Feedback</strong>
							</h3>
							<p>
								<span>
									You automatically grant and assign to us, a royalty-free,
									worldwide, irrevocable, perpetual license to use and
									incorporate into our sites and services any suggestions,
									enhancement requests, recommendations or other feedback
									provided by you.
								</span>
							</p>
							<h3>
								<strong>Waiver</strong>
							</h3>
							<p>
								<span>
									Any failure by us to enforce or exercise any provision of
									these TOU, or any related right, will not constitute a waiver
									of that provision or right.
								</span>
								<br />
								<br />
							</p>
							<p>
								<span>Last updated: November 11, 2023</span>
							</p>
						</Box>
					</Box>
				</Container>
			</Box>
			<Footer />
		</React.Fragment>
	);
};

export default Terms;
export const loader = (route) =>
	loadable(() => import("./Terms.component"), { ssr: !!route.ssr });
